var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _linearGradient0, _path0, _linearGradient1, _path1, _linearGradient10, _path10, _linearGradient11, _path11, _linearGradient12, _path12, _linearGradient13, _path13, _linearGradient14, _path14, _linearGradient15, _path15, _linearGradient16, _path16, _linearGradient17, _path17, _linearGradient18, _path18, _linearGradient19, _path19, _linearGradient20, _path20, _linearGradient21, _path21, _linearGradient22, _path22, _linearGradient23, _path23, _linearGradient24, _path24, _linearGradient25, _path25, _linearGradient26, _path26, _linearGradient27, _path27, _linearGradient28, _path28, _linearGradient29, _path29, _linearGradient30, _path30, _linearGradient31, _path31, _linearGradient32, _path32, _linearGradient33, _path33, _linearGradient34, _path34, _linearGradient35, _path35, _linearGradient36, _path36, _linearGradient37, _path37, _linearGradient38, _path38, _linearGradient39, _path39, _linearGradient40, _path40, _linearGradient41, _path41, _linearGradient42, _path42, _linearGradient43, _path43, _linearGradient44, _path44, _linearGradient45, _path45, _linearGradient46, _path46, _linearGradient47, _path47, _linearGradient48, _path48, _linearGradient49, _path49, _linearGradient50, _path50, _linearGradient51, _path51, _linearGradient52, _path52, _linearGradient53, _path53, _linearGradient54, _path54, _linearGradient55, _path55, _linearGradient56, _path56, _linearGradient57, _path57, _linearGradient58, _path58, _linearGradient59, _path59, _linearGradient60, _path60, _linearGradient61, _path61, _linearGradient62, _path62, _linearGradient63, _path63, _linearGradient64, _path64, _linearGradient65, _path65, _linearGradient66, _path66, _linearGradient67, _path67, _linearGradient68, _path68, _linearGradient69, _path69, _linearGradient70, _path70, _linearGradient71, _path71, _linearGradient72, _path72, _linearGradient73, _path73, _linearGradient74, _path74, _linearGradient75, _path75, _linearGradient76, _path76, _linearGradient77, _path77, _linearGradient78, _path78, _linearGradient79, _path79, _linearGradient80, _path80, _linearGradient81, _path81, _linearGradient82, _path82, _linearGradient83, _path83, _linearGradient84, _path84, _linearGradient85, _path85, _linearGradient86, _path86, _linearGradient87, _path87, _linearGradient88, _path88, _linearGradient89, _path89, _linearGradient90, _path90, _linearGradient91, _path91, _linearGradient92, _path92, _linearGradient93, _path93, _linearGradient94, _path94, _linearGradient95, _path95, _linearGradient96, _path96, _linearGradient97, _path97, _linearGradient98, _path98, _linearGradient99, _path99, _linearGradient100, _path100, _linearGradient101, _path101, _linearGradient102, _path102, _linearGradient103, _path103, _linearGradient104, _path104, _linearGradient105, _path105, _linearGradient106, _path106, _linearGradient107, _path107, _linearGradient108, _path108, _linearGradient109, _path109, _linearGradient110, _path110, _path111, _path112, _linearGradient111, _path113, _linearGradient112, _path114, _linearGradient113, _path115, _linearGradient114, _path116, _linearGradient115, _path117, _linearGradient116, _path118, _linearGradient117, _path119, _linearGradient118, _path120, _linearGradient119, _path121, _linearGradient120, _path122, _linearGradient121, _path123, _linearGradient122, _path124, _linearGradient123, _path125, _linearGradient124, _path126, _path127, _linearGradient125, _path128, _linearGradient126, _path129, _linearGradient127, _path130, _linearGradient128, _path131, _linearGradient129, _path132, _linearGradient130, _path133, _linearGradient131, _path134, _linearGradient132, _path135, _linearGradient133, _path136, _linearGradient134, _path137, _linearGradient135, _path138, _linearGradient136, _path139, _linearGradient137, _path140, _linearGradient138, _path141, _linearGradient139, _path142, _linearGradient140, _path143, _linearGradient141, _path144, _linearGradient142, _path145, _linearGradient143, _path146, _linearGradient144, _path147, _linearGradient145, _path148, _linearGradient146, _path149, _linearGradient147, _path150, _linearGradient148, _path151, _linearGradient149, _path152, _linearGradient150, _path153, _linearGradient151, _path154, _linearGradient152, _path155, _linearGradient153, _path156, _linearGradient154, _path157, _linearGradient155, _path158, _linearGradient156, _path159, _linearGradient157, _path160, _linearGradient158, _path161, _linearGradient159, _path162, _linearGradient160, _path163, _linearGradient161, _path164, _linearGradient162, _path165, _linearGradient163, _path166, _linearGradient164, _path167, _linearGradient165, _path168, _linearGradient166, _path169, _linearGradient167, _path170, _linearGradient168, _path171, _linearGradient169, _path172, _linearGradient170, _path173, _linearGradient171, _path174, _linearGradient172, _path175, _linearGradient173, _path176, _linearGradient174, _path177, _linearGradient175, _path178, _linearGradient176, _path179, _linearGradient177, _path180, _linearGradient178, _path181, _linearGradient179, _path182, _linearGradient180, _path183, _linearGradient181, _path184, _linearGradient182, _path185, _linearGradient183, _path186, _linearGradient184, _path187, _linearGradient185, _path188, _linearGradient186, _path189, _linearGradient187, _path190, _linearGradient188, _path191, _linearGradient189, _path192, _linearGradient190, _path193, _linearGradient191, _path194, _linearGradient192, _path195, _linearGradient193, _path196, _linearGradient194, _path197, _linearGradient195, _path198, _linearGradient196, _path199, _linearGradient197, _path200, _linearGradient198, _path201, _linearGradient199, _path202, _linearGradient200, _path203, _linearGradient201, _path204, _linearGradient202, _path205, _linearGradient203, _path206, _linearGradient204, _path207, _linearGradient205, _path208, _linearGradient206, _path209, _linearGradient207, _path210, _linearGradient208, _path211, _linearGradient209, _path212, _linearGradient210, _path213, _linearGradient211, _path214, _linearGradient212, _path215, _linearGradient213, _path216, _linearGradient214, _path217, _linearGradient215, _path218, _linearGradient216, _path219, _linearGradient217, _path220, _linearGradient218, _path221, _path222, _path223, _linearGradient219, _path224, _path225, _linearGradient220, _path226, _linearGradient221, _path227, _linearGradient222, _path228, _linearGradient223, _path229, _linearGradient224, _path230, _linearGradient225, _path231, _linearGradient226, _path232, _linearGradient227, _path233, _linearGradient228, _path234, _linearGradient229, _path235, _linearGradient230, _path236, _linearGradient231, _path237, _linearGradient232, _path238, _linearGradient233, _path239, _linearGradient234, _path240, _linearGradient235, _path241, _linearGradient236, _path242, _linearGradient237, _path243, _linearGradient238, _path244, _linearGradient239, _path245, _linearGradient240, _path246, _linearGradient241, _path247, _linearGradient242, _path248, _linearGradient243, _path249, _linearGradient244, _path250, _linearGradient245, _path251, _linearGradient246, _path252, _linearGradient247, _path253, _linearGradient248, _path254, _linearGradient249, _path255, _linearGradient250, _path256, _linearGradient251, _path257, _linearGradient252, _path258, _linearGradient253, _path259, _linearGradient254, _path260, _linearGradient255, _path261, _linearGradient256, _path262, _linearGradient257, _path263, _linearGradient258, _path264, _linearGradient259, _path265, _linearGradient260, _path266, _linearGradient261, _path267, _linearGradient262, _path268, _linearGradient263, _path269, _linearGradient264, _path270, _linearGradient265, _path271, _linearGradient266, _path272, _linearGradient267, _path273, _linearGradient268, _path274, _linearGradient269, _path275, _linearGradient270, _path276, _linearGradient271, _path277, _linearGradient272, _path278, _linearGradient273, _path279, _linearGradient274, _path280, _linearGradient275, _path281, _linearGradient276, _path282, _linearGradient277, _path283, _linearGradient278, _path284, _linearGradient279, _path285, _linearGradient280, _path286, _linearGradient281, _path287, _linearGradient282, _path288, _linearGradient283, _path289, _linearGradient284, _path290, _linearGradient285, _path291, _linearGradient286, _path292, _linearGradient287, _path293, _linearGradient288, _path294, _linearGradient289, _path295, _linearGradient290, _path296, _linearGradient291, _path297, _linearGradient292, _path298, _linearGradient293, _path299, _linearGradient294, _path300, _linearGradient295, _path301, _linearGradient296, _path302, _linearGradient297, _path303, _linearGradient298, _path304, _linearGradient299, _path305, _linearGradient300, _path306, _linearGradient301, _path307, _linearGradient302, _path308, _linearGradient303, _path309, _linearGradient304, _path310, _linearGradient305, _path311, _linearGradient306, _path312, _linearGradient307, _path313, _linearGradient308, _path314, _linearGradient309, _path315, _linearGradient310, _path316, _linearGradient311, _path317, _linearGradient312, _path318, _linearGradient313, _path319, _linearGradient314, _path320, _linearGradient315, _path321, _linearGradient316, _path322, _linearGradient317, _path323, _linearGradient318, _path324, _linearGradient319, _path325, _linearGradient320, _path326, _linearGradient321, _path327, _linearGradient322, _path328, _linearGradient323, _path329, _linearGradient324, _path330, _linearGradient325, _path331, _linearGradient326, _path332, _linearGradient327, _path333, _linearGradient328, _path334, _linearGradient329, _path335, _linearGradient330, _path336, _linearGradient331, _path337, _linearGradient332, _path338, _linearGradient333, _path339, _linearGradient334, _path340, _linearGradient335, _path341, _linearGradient336, _path342, _linearGradient337, _path343, _linearGradient338, _path344, _linearGradient339, _path345, _linearGradient340, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem12B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 310 612 252",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 611.05,
    x2: 638.75,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M442.7 360.1h-8.2v-6.3h8.2v.1h8.4v6.2z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 624.85,
    x2: 652.55,
    y1: 111.22,
    y2: 111.22,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M451.1 360.1h8.3v6.3H442.7v-6.3z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 624.85,
    x2: 652.55,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M459.4 347.6v6.3H442.7v-6.3z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 638.75,
    x2: 666.45,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M467.6 360.1h-16.5v-6.2h8.3v-.1h8.2z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 611.2,
    x2: 638.9,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M434.5 360.1h8.2v6.3h-8.2z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 611.2,
    x2: 638.9,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M434.5 347.6h8.2v6.2h-8.2z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 624.85,
    x2: 652.55,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M442.7 372.8H459.4v6.3H442.7v-.3z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 611.2,
    x2: 638.9,
    y1: 132.15,
    y2: 132.15,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M434.5 372.8h8.2v6.1h-8.2v-6.1z",
    fill: "url(#h)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 611.05,
    x2: 638.75,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M442.7 372.8h-8.2v-6.4h16.6v6.4z"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 611.05,
    x2: 638.75,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M442.7 385.2h-8.2v-6.3h8.2v.2h8.3v6.1h-8.3z",
    fill: "url(#j)"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 638.75,
    x2: 666.45,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M467.6 372.8h-16.5v-6.4h16.5z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 611.05,
    x2: 638.75,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M442.7 397.8h-8.2v-6.4h8.2v.1h8.4v6.3z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 611.2,
    x2: 638.9,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M434.5 385.2h8.2v6.2h-8.2z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 624.85,
    x2: 652.55,
    y1: 153.1,
    y2: 153.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M459.4 391.4v.1H442.7v-6.3H459.4z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 638.75,
    x2: 666.45,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M467.7 385.2h-16.6v-6.1h8.3v-.3h8.3v6.3z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 680.4,
    x2: 708.1,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M475.9 353.8v-6.2H492.6v6.3H475.9z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 666.5,
    x2: 694.2,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M475.9 360.1H467.6v-6.3H475.9v.1h8.3v6.2z"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 680.4,
    x2: 708.1,
    y1: 111.17,
    y2: 111.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M475.9 366.4v-6.3H492.6v6.3h-8.4z"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 694.25,
    x2: 721.95,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M492.6 353.8h8.2v6.3h-16.6v-6.2h8.4z"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 666.7,
    x2: 694.4,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M467.7 347.6h8.2v6.2h-8.2z"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 708.25,
    x2: 735.95,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M500.8 353.8h-8.2v-6.2h8.2z"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 652.75,
    x2: 680.45,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M459.4 353.8v-6.2h8.3v6.2h-.1z"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 652.75,
    x2: 680.45,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M467.7 366.4H459.4v-6.3H467.7z"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 666.5,
    x2: 694.2,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M467.7 366.4h16.5v6.3h-8.3v.1H467.6v-6.4z"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 652.75,
    x2: 680.45,
    y1: 132.15,
    y2: 132.15,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M467.7 378.8h-8.3v-6H467.7z"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 666.7,
    x2: 694.4,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M467.7 372.8h8.2v6.3h-8.2z"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 638.75,
    x2: 666.45,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M459.4 391.4h8.3v6.4h-16.6v-6.3h8.3z"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 652.75,
    x2: 680.45,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M459.4 385.2h8.3v6.2h-8.3z"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 708.25,
    x2: 735.95,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M500.8 372.8v6.3h-8.2v-6.3z"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 680.4,
    x2: 708.1,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M475.9 372.8v-.1H492.6V379.1h-16.7z"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 694.25,
    x2: 721.95,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M484.2 372.7v-6.3h16.6v6.4h-8.2v-.1z"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 666.7,
    x2: 694.4,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M467.7 360.1h8.2v6.3h-8.2z"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 708.25,
    x2: 735.95,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M500.8 366.4h-8.2v-6.3h8.2z"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 763.7,
    x2: 791.4,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M525.7 353.8v-6.2h8.3v6.2h-.1z"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 777.45,
    x2: 805.15,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M542.3 360.1h-8.4v-6.3h8.4v.1h8.2v6.2z"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 749.75,
    x2: 777.45,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M525.7 353.8h8.2v6.3h-16.5v-6.2h8.3z"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 735.85,
    x2: 763.55,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M509.1 353.8v-6.2h16.6v6.3h-16.6z"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 735.85,
    x2: 763.55,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M517.4 360.1h8.3v6.3h-16.6v-6.3h.1z"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 763.7,
    x2: 791.4,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M525.7 366.4v-6.3H534v6.3h-.1z"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 791.35,
    x2: 819.05,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M558.9 347.6v6.3h-16.6v-6.3z"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 791.35,
    x2: 819.05,
    y1: 111.17,
    y2: 111.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M558.9 360.1v6.3h-16.6v-6.3h8.2z"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 777.65,
    x2: 805.35,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M534 347.6h8.2v6.2H534z"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 777.65,
    x2: 805.35,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M534 360.1h8.2v6.3H534z"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 722.2,
    x2: 749.9,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M500.9 347.6h8.2v6.2h-8.2z"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 722,
    x2: 749.7,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M509.1 360.1H500.8v-6.3H509.1v.1h8.3v6.2h-8.2z"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 722.2,
    x2: 749.9,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M500.9 360.1h8.2v6.3h-8.2z"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 722,
    x2: 749.7,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M509.1 372.8H500.8v-6.4h16.6v6.3h-8.3z"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 749.75,
    x2: 777.45,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M525.7 372.8v-.1h-8.3v-6.3h16.5v6.4z"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 735.85,
    x2: 763.55,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M517.4 372.7h8.3V379.1h-16.6V372.7z"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 722.2,
    x2: 749.9,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M500.9 372.8h8.2v6.3h-8.2z"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 777.45,
    x2: 805.15,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M533.9 372.8v-6.4h16.6v6.3h-8.2v.1H534z"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 791.35,
    x2: 819.05,
    y1: 132.12,
    y2: 132.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M558.9 378.8h-16.6v-6.1h16.6v.1z"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 777.65,
    x2: 805.35,
    y1: 132.15,
    y2: 132.15,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M534 372.8h8.2v6.1H534z"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 763.7,
    x2: 791.4,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M534 378.8h-.1v.3h-8.2v-6.3H534z"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 777.4,
    x2: 805.1,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M542.3 378.8h8.2v6.3h-8.3v.1h-8.3V378.8h.1z"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 777.4,
    x2: 805.1,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M550.5 391.4v6.4h-16.6v-6.4h8.3z"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 777.55,
    x2: 805.25,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M533.9 385.2h8.2v6.2h-8.2z"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 791.25,
    x2: 818.95,
    y1: 153.02,
    y2: 153.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M550.5 391.4h-8.3v-6.3h16.6v6.3z"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 805.2,
    x2: 832.9,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M558.9 353.8h8.2v6.3h-16.6v-6.2h8.4z"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 819.25,
    x2: 846.95,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M558.9 353.8v-6.2h8.3v6.3h-.1v-.1z"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 819.25,
    x2: 846.95,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M558.9 366.4v-6.3H567.2v6.3h-.1z"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 819.25,
    x2: 846.95,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M558.9 378.8v-6h8.2v-.1h.1v6.4h-.1v-.3z"
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 805.15,
    x2: 832.85,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M567.1 385.2h-8.3v-.1h-8.3v-6.3h16.6v.3z"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 805.2,
    x2: 832.9,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M550.5 366.4h16.6V372.8h-8.2v-.1h-8.4z"
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 819.1,
    x2: 846.8,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M558.8 385.2h8.3v6.2h-8.3z"
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 805.15,
    x2: 832.85,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M550.5 397.8v-6.4h16.6v6.4h-8.3z"
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 819.1,
    x2: 846.8,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M558.8 397.8h8.3v6.3h-8.3z"
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 805.15,
    x2: 832.85,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M558.8 404.1h8.3v6.3h-8.3v-.1h-8.3v-6.2z"
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 777.4,
    x2: 805.1,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M533.9 404.1h16.6v6.2h-8.3v.1h-8.3z"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 791.25,
    x2: 818.95,
    y1: 195.25,
    y2: 195.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M542.2 416.7V410.3h16.6V416.7h-16.5z"
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 791.25,
    x2: 818.95,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M558.8 404.1h-16.6v-6.3h16.6z"
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 805.15,
    x2: 832.85,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M550.5 423v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 777.4,
    x2: 805.1,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M542.2 423h-8.3v-6.3h16.6v6.3z"
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 791.25,
    x2: 818.95,
    y1: 216.37,
    y2: 216.37,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M542.2 429.3V423h16.6v6.3h-8.3z"
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 819.1,
    x2: 846.8,
    y1: 195.3,
    y2: 195.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M558.8 410.4h8.3v6.3h-8.3z"
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 819.1,
    x2: 846.8,
    y1: 216.42,
    y2: 216.42,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M558.8 423h8.3v6.2h-8.3z"
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 805.15,
    x2: 832.85,
    y1: 226.95,
    y2: 226.95,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M558.8 429.3h8.3v6.3h-16.6v-6.3z"
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 777.4,
    x2: 805.1,
    y1: 226.95,
    y2: 226.95,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M542.2 435.6h-8.3v-6.3h16.6v6.3z"
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 791.25,
    x2: 818.95,
    y1: 236.97,
    y2: 236.97,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M542.2 441.3v-5.7h16.6v5.7h-8.3z"
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 819.1,
    x2: 846.8,
    y1: 257.65,
    y2: 257.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M558.8 447.7h8.3v6.3h-8.3z"
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 791.25,
    x2: 818.95,
    y1: 257.6,
    y2: 257.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M542.2 453.9v-6.3h16.6v6.3h-16.5z"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 805.15,
    x2: 832.85,
    y1: 247.1,
    y2: 247.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M558.8 441.3h8.3v6.4h-8.3v-.1h-8.3v-6.3z"
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 777.4,
    x2: 805.1,
    y1: 247.1,
    y2: 247.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M542.2 447.7h-8.3v-6.4h16.6v6.3h-8.3z"
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 819.1,
    x2: 846.8,
    y1: 237.02,
    y2: 237.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M558.8 435.6h8.3v5.7h-8.3z"
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 777.55,
    x2: 805.25,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M533.9 397.8h8.2v6.3h-8.2z"
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 777.55,
    x2: 805.25,
    y1: 195.3,
    y2: 195.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M533.9 410.4h8.2v6.3h-8.2z"
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 777.55,
    x2: 805.25,
    y1: 216.42,
    y2: 216.42,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M533.9 423h8.2v6.2h-8.2z"
  })), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 777.55,
    x2: 805.25,
    y1: 257.65,
    y2: 257.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M533.9 447.7h8.2v6.3h-8.2z"
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 777.55,
    x2: 805.25,
    y1: 237.02,
    y2: 237.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M533.9 435.6h8.2v5.7h-8.2z"
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 652.75,
    x2: 680.45,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M459.4 397.8h8.3v6.3h-8.3z"
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 638.75,
    x2: 666.45,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M451.1 410.4v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 624.85,
    x2: 652.55,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M442.7 397.8H459.4v6.3H442.7z"
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 624.85,
    x2: 652.55,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M459.4 416.1v.6H442.7v-6.3H459.4v5.6z"
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 652.75,
    x2: 680.45,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M459.4 410.4h8.3V416.7h-8.3v-.7z"
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 624.85,
    x2: 652.55,
    y1: 216.02,
    y2: 216.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M459.4 423.2v5.6H442.7V423H459.4z"
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 652.75,
    x2: 680.45,
    y1: 216,
    y2: 216,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M467.7 428.8h-8.3V423h8.3z"
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 638.75,
    x2: 666.45,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M451.1 423v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 638.75,
    x2: 666.45,
    y1: 226.1,
    y2: 226.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M451.1 435v-6.2h16.6v6.3h-8.3v-.1z"
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 624.85,
    x2: 652.55,
    y1: 236.1,
    y2: 236.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M459.4 440.8H442.7V435H459.4v.1z"
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 624.85,
    x2: 652.55,
    y1: 256.8,
    y2: 256.8,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M442.7 453.4v-6.2H459.4v6.2z"
  })), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 652.75,
    x2: 680.45,
    y1: 256.8,
    y2: 256.8,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M459.4 447.2h8.3v6.3h-8.3z"
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 638.75,
    x2: 666.45,
    y1: 246.25,
    y2: 246.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M451.1 440.8h16.6V447.2h-16.6z"
  })), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 652.75,
    x2: 680.45,
    y1: 236.17,
    y2: 236.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M459.4 435.1h8.3v5.7h-8.3z"
  })), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 611.2,
    x2: 638.9,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M434.5 397.8h8.2v6.3h-8.2z"
  })), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 611.05,
    x2: 638.75,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M442.7 410.4h-8.2v-6.3h16.6v6.3z"
  })), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 611.2,
    x2: 638.9,
    y1: 216,
    y2: 216,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M442.7 428.8h-8.2V423h8.2z"
  })), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 611.05,
    x2: 638.75,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M442.7 423h-8.2v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 611.2,
    x2: 638.9,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "M434.5 410.4h8.2v6.3h-8.2v-.7z"
  })), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 611.05,
    x2: 638.75,
    y1: 226.1,
    y2: 226.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#be)",
    d: "M434.5 428.8h16.6v6.2h-8.4v.1h-8.2z"
  })), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 611.2,
    x2: 638.9,
    y1: 256.8,
    y2: 256.8,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M434.5 447.2h8.2v6.3h-8.2z"
  })), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 611.05,
    x2: 638.75,
    y1: 246.25,
    y2: 246.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "M442.7 447.2h-8.2v-6.4h16.6v6.4z"
  })), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 611.2,
    x2: 638.9,
    y1: 236.17,
    y2: 236.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "M434.5 435.1h8.2v5.7h-8.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M434.5 360.1v0-6.3h0v-6.2h33.1v6.2h0v-6.2h8.2m.2 0h16.5m.1 0h8.3v6.2h0v-6.2H534v6.2h0v-6.2h33.1v6.3h0v6.2h0v6.3h0v6.3h0v6.3h-.1v6.1h0v6.2h0v6.3h0v6.3h0v6.3h0v6.3h-33.2v-6.3h0v-6.3h0v-6.3h0v-6.3h0v-6.2h0V379h-33v-6.3h0v6.3h-33.1v-6.3h0v6.1m0 .3v6.1m0 0v49.6m0 .3v5.7m0 .6v5.7m0 .1v6.3h-33.1v-6.3h0v-6.3h0v-5.7h0v-6.3h0V423h0v-6.3h0v-6.3h0v-6.3h0v-6.3h0v-6.3h0v-6.2h0V379h0v-6.1h0v-6.3h0v-6.3m16.5-.2h-8.3v6.3h16.6v-6.3h-8.3v-6.2h-8.3v-.1h-8.2m8.1 6.3h-8.2m8.2-6.3v-6.2m0 25.2v6.3h16.6v-6.3h-24.8m8.2 6h-8.2m16.6-6v-6.3m0 25h-8.3v0h-8.2m16.5-6.3h-8.3v6.2m-8.3-25h8.2m8.4 18.8v-6.1m-8.4 6.1h-8.2m49.7-31.3h-8.3v-.1h-8.2m8.2 6.3v0h8.3v-6.2m8.4-.1v0l-8.3.1m-.1 6.2h8.3v0h8.2v-6.3h-8.2m.1-6.2v6.2m-16.7 0v-6.2m-16.5 6.2v0l-8.3.1m16.5 6.2v-6.3h-8.3v-6.2m8.3 6.2v0m.1 6.3v6.3h0v-6.3zm0 0v0h-8.3m8.2 12.7v-6.3h-8.3m8.4 6.3v0h-8.3m8.2-6.4v0m-8.2 25v-6.2h-8.3m8.3 6.2v0h-8.3v6.3h16.6m-8.3-18.9h8.3m0 6.4h-8.3m0 6.2h8.3m24.9-18.6v6.3m-8.4-6.4h8.3v0h8.2v-6.3h-16.5v6.3zm-8.3 6.4v-6.3h-8.2m8.2 0v0h8.3m-8.3-6.4h8.3m8.4-6.3v6.3m-16.7 0v-6.3h-8.2m0 6.3h8.2m49.8-12.6v0l-8.3.1v6.2h8.3v0h8.2v-6.3h-8.2zm8.3 6.3v6.3h0v-6.3zm0 0v0m8.3 0v0h8.3v-6.2h-8.3v-.1H534m8.3 6.3H534m8.3-6.3v-6.2m-16.6 0v6.2m-8.3.1h-8.3v-.1h-8.2m0 6.3v6.3h0v-6.3zm-.1 0v0m8.4 0h8.2m-8.3 0v0m0 0h-8.2m8.2-6.3v-6.2m8.3 25.1v-6.3h-8.3v0h-8.2m8.2 6.4v0h16.6v0m-24.9-6.4v0m0 6.4v0m8.3 0h-8.2m8.2 6.3v-6.3m33.2 0v0h8.3v-6.3H534m8.3 12.3v-6.1H534v6.1h8.3zm-8.3-6v6.1h0m0-6.1v0h-8.3v6.3m8.2-12.7v0m0 6.4v-6.3h-8.2v0h-8.3m16.5 12.6v-.2h.1m8.2 12.5v-6.2H534m8.2 0v0l8.3-.1v-6.3h-8.2m-8.4 12.6h16.5m-8.1-25v-6.3m-16.6 0v6.3m-16.6 0v-6.3m41.4 0h8.3v0h8.3v0m-8.2-6.2h-8.3m8.3-.1h8.3v.1m-8.3-.1v-6.2m0 31.2h8.2v.2m0-6.3v0h-8.3v6.1m.1-12.4h8.3v0m-16.7 6.3h8.3v0m-8.3 6.1h8.4m-8.4-12.4h8.3v-6.3m-8.3 25h8.3v.1h8.3m-16.6 6.2h8.3v-6.2m0 6.2h8.3m-8.3 12.7v-6.3h-16.6v6.3h24.9m-16.6 6.2V404m0 6.3h8.3v.1h8.3M550.5 423h8.3v.1h8.3v-6.3h-16.6v6.2zm8.3-12.6v6.3m0-18.9h8.3m0 31.5v6.3h0v5.7h0v6.3h0v6.3h-33.2v-6.3h0v-6.3h0v-5.7h0v-6.3h0V423h0v-6.3h16.6m0 12.6h8.3V423m-8.3 12.6v-6.3H534m16.5 6.3h8.3v.1h8.3m-16.6 11.9v-6.3H534m16.5 6.3h8.3v.1h8.3m-16.6-6.4h8.3v-5.7m0 12.1v6.3m0-12.7h8.3m-8.3-12h8.3V423m-24.9-12.6v0l8.3-.1m-8.3 12.7v0l8.3-.1m-8.3.1H534m8.2-6.3v-6.3H534m-.1-6.3h8.2m-8.2-6.3h8.2m.1 37.8v0l8.3-.1m-8.3 12.2v0l8.3-.1m-8.3 6.3v-6.3H534m8.2-6.3v-5.7H534m8.2-6.3V423m-82.8-18.9v-6.3m0 18.2v-5.6h-16.6v6.3h16.6v-.6m0 6.9h-16.5m-.2 0v5.7h16.6v-5.6m.1-19h8.3m-8.3 12.6h8.3m-8.3 6.3h8.3m-8.3-12.6h8.3M451.1 435h8.3v.1h8.3m-8.3 18.3v-6.3h-16.6v6.3m16.6-24.6h8.3m0 18.4h-8.3m0-6.4v-5.7m0 5.7h8.3m-25-43v6.3h16.6m-8.2-6.3h-8.3m8.3 12.6v-6.3m0 18.9v-6.3m-8.4-12.6h-8.2m0-6.3h8.2m-8.2 18.9h8.2m-8.2-6.3h8.2m0 12.6h-8.2m16.6 12v-6.2m-8.4 6.3v0l8.3-.1m.1 12.2v-6.3h-16.5m8.1-5.8h-8.2m0-6.3h8.2m0 12v-5.7m0 12.1h-8.2m16.6-6.4h8.3m91.1-43v-6.3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    d: "M434.8 378.9h132.4"
  })), _linearGradient111 || (_linearGradient111 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 437.65,
    x2: 465.35,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi)",
    d: "M330.8 353.8v-6.2h8.3v6.2z"
  })), _linearGradient112 || (_linearGradient112 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 423.7,
    x2: 451.4,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M339.1 353.8v6.3h-16.6v-6.3h8.3z"
  })), _linearGradient113 || (_linearGradient113 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 451.4,
    x2: 479.1,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bk)",
    d: "M347.4 360.1h-8.3v-6.3h16.6v6.3z"
  })), _linearGradient114 || (_linearGradient114 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 437.65,
    x2: 465.35,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M330.8 366.4v-6.3h8.3v6.3z"
  })), _linearGradient115 || (_linearGradient115 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 465.3,
    x2: 493,
    y1: 111.17,
    y2: 111.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bm)",
    d: "M364 360.1v6.3h-16.6v-6.3h8.3z"
  })), _linearGradient116 || (_linearGradient116 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 409.8,
    x2: 437.5,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "M322.5 353.9H314.2v-6.3h16.6v6.2h-8.3z"
  })), _linearGradient117 || (_linearGradient117 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 451.6,
    x2: 479.3,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo)",
    d: "M339.1 347.6h8.2v6.2h-8.2z"
  })), _linearGradient118 || (_linearGradient118 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 465.3,
    x2: 493,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M364 347.6v6.2h-16.6v-6.2z"
  })), _linearGradient119 || (_linearGradient119 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 451.6,
    x2: 479.3,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "M339.1 360.1h8.2v6.3h-8.2z"
  })), _linearGradient120 || (_linearGradient120 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 396.15,
    x2: 423.85,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M306 347.6h8.2v6.2H306z"
  })), _linearGradient121 || (_linearGradient121 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 395.95,
    x2: 423.65,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bs)",
    d: "M306 360.1h-.1v-6.3H314.2v.1H322.5v6.2H314.2z"
  })), _linearGradient122 || (_linearGradient122 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 396.15,
    x2: 423.85,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M306 366.4v-6.3h8.2v6.3h-3c-1.4-.1-2.8-.1-4.2-.1h-1 1c1.4 0 2.8 0 4.2.1H306z",
    fill: "url(#bt)"
  })), _linearGradient123 || (_linearGradient123 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 409.8,
    x2: 437.5,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bu)",
    d: "M330.8 360.1v6.3h-16.6v-6.3H322.5z"
  })), _linearGradient124 || (_linearGradient124 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 423.7,
    x2: 451.4,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M339.1 372.8h-5.9c-.7-.5-1.5-.9-2.3-1.3v-.1l-.1-.1v.1c-.4-.2-.7-.4-1.1-.5-1-.5-1.9-.9-2.9-1.3v-.2c-.2-.1-.3-.1-.4.1-1.2-.5-2.5-.9-3.9-1.2v-1.8H339v6.3z",
    fill: "url(#bv)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M330.8 371.3h.1v.1s-.1 0-.1-.1c0 0 .1 0 .1.1l-.1.1h-.1l.1-.2c-.1.1 0 .1 0 0zm-4.1-1.7c-.1 0-.2-.1-.4-.1 0-.2.1-.2.4-.1v.2c0 .1-.1.1-.2.1-.2 0-.2-.1-.2-.2.2 0 .3 0 .4.1zm-42.3.3.1-.1.1.1c-.1-.1-.2-.1-.2 0 0 0 .1 0 .1-.1l.1.1h-.2zm-3.4 1.6c0-.1.1-.1.1-.2l.1.1c-.1 0-.2 0-.2.1 0 0 .1-.1.2-.1-.1.1-.1.1-.2.1zm-7.1 6.1c-.1-.1-.1-.2-.1-.3 0-.3.1-.4.4-.4h.2c-.2.2-.4.5-.5.7z",
    fill: "#666"
  })), _linearGradient125 || (_linearGradient125 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 395.95,
    x2: 423.65,
    y1: 117.94,
    y2: 117.94,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M314.2 366.4h8.3v1.8c-.5-.1-.9-.3-1.4-.4-.3-.1-.5-.1-.7-.2-2.9-.6-6-1.1-9.2-1.3l3 .1z",
    fill: "url(#bw)"
  })), _linearGradient126 || (_linearGradient126 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 451.4,
    x2: 479.1,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    d: "M339.1 372.8v-6.4h16.6v6.3h-8.3v.1h-8.3z"
  })), _linearGradient127 || (_linearGradient127 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 465.3,
    x2: 493,
    y1: 132.12,
    y2: 132.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#by)",
    d: "M364 378.8h-16.6v-6.1H364v.1z"
  })), _linearGradient128 || (_linearGradient128 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 451.6,
    x2: 479.3,
    y1: 132.15,
    y2: 132.15,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "M339.1 372.8h8.2v6.1h-8.2z"
  })), _linearGradient129 || (_linearGradient129 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 437.65,
    x2: 465.35,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M333.2 372.8h5.9v6.1h-.1v.2h-.4c-.7-2.4-2.6-4.5-5.4-6.3z",
    fill: "url(#bA)"
  })), _linearGradient130 || (_linearGradient130 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 451.35,
    x2: 479.05,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "M347.4 378.8h8.3v6.3h-8.4v.1h-8.2V378.8z"
  })), _linearGradient131 || (_linearGradient131 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 451.35,
    x2: 479.05,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bC)",
    d: "M355.7 391.4v6.4h-16.6v-6.4h16.5z"
  })), _linearGradient132 || (_linearGradient132 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 451.5,
    x2: 479.2,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M339.1 385.2h8.2v6.2h-8.2z"
  })), _linearGradient133 || (_linearGradient133 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 465.2,
    x2: 492.9,
    y1: 153.02,
    y2: 153.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bE)",
    d: "M355.6 391.4h-8.3v-6.3h16.6v6.3h-8.2z"
  })), _linearGradient134 || (_linearGradient134 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 479.15,
    x2: 506.85,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "M364 353.8h8.3v6.3h-16.6v-6.3z"
  })), _linearGradient135 || (_linearGradient135 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 493.2,
    x2: 520.9,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bG)",
    d: "M372.3 353.9v-.1H364v-6.2h8.3z"
  })), _linearGradient136 || (_linearGradient136 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 493.2,
    x2: 520.9,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "M364 366.4v-6.3h8.3v6.3z"
  })), _linearGradient137 || (_linearGradient137 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 479.15,
    x2: 506.85,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bI)",
    d: "M355.7 366.4h16.6V372.8H364v-.1h-8.3z"
  })), _linearGradient138 || (_linearGradient138 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 493.2,
    x2: 520.9,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "M372.3 379.1v-.3H364v-6h8.3v-.1z"
  })), _linearGradient139 || (_linearGradient139 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 479.1,
    x2: 506.8,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bK)",
    d: "M372.2 385.2h-8.3v-.1h-8.2v-6.3h16.6V385.2z"
  })), _linearGradient140 || (_linearGradient140 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 493.05,
    x2: 520.75,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "M363.9 385.2h8.3v6.2h-8.3z"
  })), _linearGradient141 || (_linearGradient141 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 479.1,
    x2: 506.8,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "M355.7 397.8v-6.4h16.6v6.4h-8.4z"
  })), _linearGradient142 || (_linearGradient142 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 493.05,
    x2: 520.75,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M363.9 397.8h8.3v6.3h-8.3z"
  })), _linearGradient143 || (_linearGradient143 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 479.1,
    x2: 506.8,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bO)",
    d: "M363.9 404.1h8.4v6.3h-8.4v-.1h-8.2v-6.2z"
  })), _linearGradient144 || (_linearGradient144 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 451.35,
    x2: 479.05,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "M339.1 404.1h16.6v6.2h-8.4v.1h-8.2z"
  })), _linearGradient145 || (_linearGradient145 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 465.2,
    x2: 492.9,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bQ)",
    d: "M355.7 404.1h-8.4v-6.3h16.6v6.3z"
  })), _linearGradient146 || (_linearGradient146 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 465.2,
    x2: 492.9,
    y1: 195.25,
    y2: 195.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "M347.3 416.7V410.3h16.6V416.7h-16.5z"
  })), _linearGradient147 || (_linearGradient147 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 479.1,
    x2: 506.8,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "M355.7 423v-6.3h16.6v6.3h-8.4z"
  })), _linearGradient148 || (_linearGradient148 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 451.35,
    x2: 479.05,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "M347.3 423h-8.2v-6.3h16.6v6.3z"
  })), _linearGradient149 || (_linearGradient149 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 465.2,
    x2: 492.9,
    y1: 216.37,
    y2: 216.37,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bU)",
    d: "M355.7 429.3h-8.4V423h16.6v6.3z"
  })), _linearGradient150 || (_linearGradient150 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 493.05,
    x2: 520.75,
    y1: 195.3,
    y2: 195.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "M363.9 410.4h8.3v6.3h-8.3z"
  })), _linearGradient151 || (_linearGradient151 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 493.05,
    x2: 520.75,
    y1: 216.42,
    y2: 216.42,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "M363.9 423h8.3v6.2h-8.3z"
  })), _linearGradient152 || (_linearGradient152 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 479.1,
    x2: 506.8,
    y1: 226.95,
    y2: 226.95,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M363.9 429.3h8.4v6.3h-16.6v-6.3z"
  })), _linearGradient153 || (_linearGradient153 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 451.35,
    x2: 479.05,
    y1: 226.95,
    y2: 226.95,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "M347.3 429.3h8.4v6.3h-16.6v-6.3z"
  })), _linearGradient154 || (_linearGradient154 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 465.2,
    x2: 492.9,
    y1: 236.97,
    y2: 236.97,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "M347.3 441.3v-5.7h16.6v5.7h-8.3z"
  })), _linearGradient155 || (_linearGradient155 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 493.05,
    x2: 520.75,
    y1: 257.65,
    y2: 257.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ca)",
    d: "M363.9 447.7h8.3v6.3h-8.3z"
  })), _linearGradient156 || (_linearGradient156 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 465.2,
    x2: 492.9,
    y1: 257.6,
    y2: 257.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M347.3 453.9v-6.3h16.6v6.3h-16.5z"
  })), _linearGradient157 || (_linearGradient157 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 479.1,
    x2: 506.8,
    y1: 247.1,
    y2: 247.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "M363.9 441.3h8.4v6.4h-8.4v-.1h-8.3v-6.3z"
  })), _linearGradient158 || (_linearGradient158 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 451.35,
    x2: 479.05,
    y1: 247.1,
    y2: 247.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M347.3 447.7h-8.2v-6.4h16.5v6.3h-8.3z"
  })), _linearGradient159 || (_linearGradient159 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 493.05,
    x2: 520.75,
    y1: 237.02,
    y2: 237.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "M363.9 435.6h8.3v5.7h-8.3z"
  })), _linearGradient160 || (_linearGradient160 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 451.5,
    x2: 479.2,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "M339.1 397.8h8.2v6.3h-8.2z"
  })), _linearGradient161 || (_linearGradient161 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 451.5,
    x2: 479.2,
    y1: 216.42,
    y2: 216.42,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg)",
    d: "M339.1 423h8.2v6.2h-8.2z"
  })), _linearGradient162 || (_linearGradient162 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 451.5,
    x2: 479.2,
    y1: 195.3,
    y2: 195.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ch)",
    d: "M339.1 410.4h8.2v6.3h-8.2z"
  })), _linearGradient163 || (_linearGradient163 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 451.5,
    x2: 479.2,
    y1: 257.65,
    y2: 257.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ci)",
    d: "M339.1 447.7h8.2v6.3h-8.2z"
  })), _linearGradient164 || (_linearGradient164 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 451.5,
    x2: 479.2,
    y1: 237.02,
    y2: 237.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cj)",
    d: "M339.1 435.6h8.2v5.7h-8.2z"
  })), _linearGradient165 || (_linearGradient165 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 285,
    x2: 312.7,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ck)",
    d: "M247.9 360.1H239.6v-6.3h16.6v6.3z"
  })), _linearGradient166 || (_linearGradient166 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 298.8,
    x2: 326.5,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cl)",
    d: "M247.9 353.8v-6.2h16.6v6.2h-8.3z"
  })), _linearGradient167 || (_linearGradient167 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 298.8,
    x2: 326.5,
    y1: 111.17,
    y2: 111.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cm)",
    d: "M256.2 360.1h8.3v6.3h-16.6v-6.3z"
  })), _linearGradient168 || (_linearGradient168 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 312.7,
    x2: 340.4,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cn)",
    d: "M264.5 353.8h8.3v6.3h-16.6v-6.3z"
  })), _linearGradient169 || (_linearGradient169 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 285.15,
    x2: 312.85,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#co)",
    d: "M239.7 360.1h8.2v6.3h-8.2z"
  })), _linearGradient170 || (_linearGradient170 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 285.15,
    x2: 312.85,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cp)",
    d: "M239.7 347.6h8.2v6.2h-8.2z"
  })), _linearGradient171 || (_linearGradient171 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 285.15,
    x2: 312.85,
    y1: 132.15,
    y2: 132.15,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cq)",
    d: "M239.7 372.8h8.2v6.1h-8.2z"
  })), _linearGradient172 || (_linearGradient172 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 298.8,
    x2: 326.5,
    y1: 132.12,
    y2: 132.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "M247.9 372.8v-.1h16.6v6.1h-16.6z"
  })), _linearGradient173 || (_linearGradient173 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 285,
    x2: 312.7,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cs)",
    d: "M239.7 378.8h16.5v6.3h-8.3v.1H239.6v-6.4z"
  })), _linearGradient174 || (_linearGradient174 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 285,
    x2: 312.7,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ct)",
    d: "M239.7 366.4h16.5v6.3h-8.3v.1H239.6v-6.4z"
  })), _linearGradient175 || (_linearGradient175 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 312.7,
    x2: 340.4,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cu)",
    d: "M272.8 372.8h-8.3v-.1h-8.3v-6.3h16.6z"
  })), _linearGradient176 || (_linearGradient176 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 285,
    x2: 312.7,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cv)",
    d: "M256.2 391.4v6.4h-16.6v-6.4H247.9z"
  })), _linearGradient177 || (_linearGradient177 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 285.15,
    x2: 312.85,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cw)",
    d: "M239.7 385.2h8.2v6.2h-8.2z"
  })), _linearGradient178 || (_linearGradient178 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 298.8,
    x2: 326.5,
    y1: 153.02,
    y2: 153.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cx)",
    d: "M256.2 385.1h8.3v6.3h-16.6v-6.3z"
  })), _linearGradient179 || (_linearGradient179 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 312.7,
    x2: 340.4,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cy)",
    d: "M264.5 378.8h8.3V385.2h-8.3v-.1h-8.3v-6.3z"
  })), _linearGradient180 || (_linearGradient180 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 382.2,
    x2: 409.9,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cz)",
    d: "M297.7 353.8v-6.2h8.3v6.2h-.1z"
  })), _linearGradient181 || (_linearGradient181 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 340.45,
    x2: 368.15,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cA)",
    d: "M281.1 360.1h-8.3v-6.3h8.3v.1h8.3v6.2z"
  })), _linearGradient182 || (_linearGradient182 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 368.2,
    x2: 395.9,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cB)",
    d: "M297.7 353.8h8.2v6.3h-16.5v-6.2h8.3z"
  })), _linearGradient183 || (_linearGradient183 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 354.35,
    x2: 382.05,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cC)",
    d: "M281.1 353.8v-6.2h16.6v6.3h-16.6z"
  })), _linearGradient184 || (_linearGradient184 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 354.35,
    x2: 382.05,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cD)",
    d: "M297.7 360.1v6.3h-16.6v-6.3h8.3z"
  })), _linearGradient185 || (_linearGradient185 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 382.2,
    x2: 409.9,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M297.7 366.4v-6.3h8.2v6.3h-5.3c1.4-.1 2.8-.1 4.2-.1h1-1c-1.4 0-2.8 0-4.2.1h-2.9z",
    fill: "url(#cE)"
  })), _linearGradient186 || (_linearGradient186 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 326.7,
    x2: 354.4,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cF)",
    d: "M272.8 353.8h-8.3v-6.2H272.8z"
  })), _linearGradient187 || (_linearGradient187 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 340.65,
    x2: 368.35,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cG)",
    d: "M281.1 347.6v6.2h-8.3v-6.2h4.7z"
  })), _linearGradient188 || (_linearGradient188 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 326.7,
    x2: 354.4,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cH)",
    d: "M272.8 366.4h-8.3v-6.3h8.3z"
  })), _linearGradient189 || (_linearGradient189 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 340.65,
    x2: 368.35,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cI)",
    d: "M272.8 360.1h8.2v6.3h-8.2z"
  })), _linearGradient190 || (_linearGradient190 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 340.45,
    x2: 368.15,
    y1: 123.22,
    y2: 123.22,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M284.5 369.8c-.1 0-.2 0-.2.1-.7.3-1.5.6-2.2 1-.4.2-.7.4-1.1.6l-.1-.1c0 .1 0 .1-.1.1v.1c-.8.4-1.5.8-2.2 1.3h-5.9v-6.3h16.5v1.7c-1.5.3-3.1.9-4.7 1.5zm-8.7 4.6c.1-.3.2-.3.4-.2v.1c0 .1-.1.2-.2.2h-.1l-.1-.1z",
    fill: "url(#cJ)"
  })), _linearGradient191 || (_linearGradient191 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 340.65,
    x2: 368.35,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M272.8 372.8h5.9c-2 1.3-3.4 2.7-4.4 4.2h-.2c-.3 0-.4.1-.4.4 0 .2 0 .3.1.3-.3.5-.5.9-.6 1.4h-.4v-6.3zm3 1.6.1.1h.1c.1 0 .2-.1.2-.2v-.1c-.2-.1-.3-.1-.4.2z",
    fill: "url(#cK)"
  })), _linearGradient192 || (_linearGradient192 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 326.7,
    x2: 354.4,
    y1: 132.15,
    y2: 132.15,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL)",
    d: "M264.5 372.8h8.3v6.1h-8.3z"
  })), _linearGradient193 || (_linearGradient193 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 326.7,
    x2: 354.4,
    y1: 153.07,
    y2: 153.07,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cM)",
    d: "M264.5 385.2h8.3v6.2h-8.3z"
  })), _linearGradient194 || (_linearGradient194 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 312.7,
    x2: 340.4,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cN)",
    d: "M256.2 397.8v-6.4h16.6v6.4h-8.3z"
  })), _linearGradient195 || (_linearGradient195 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 368.2,
    x2: 395.9,
    y1: 117.92,
    y2: 117.92,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M297.7 366.4h3c-1.9.1-3.8.3-5.6.6-2 .3-3.9.7-5.8 1.2v-1.7l8.4-.1z",
    fill: "url(#cO)"
  })), _linearGradient196 || (_linearGradient196 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 326.7,
    x2: 354.4,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cP)",
    d: "M264.5 397.8h8.3v6.3h-8.3z"
  })), _linearGradient197 || (_linearGradient197 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 312.7,
    x2: 340.4,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cQ)",
    d: "M256.2 410.4v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient198 || (_linearGradient198 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 298.8,
    x2: 326.5,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cR)",
    d: "M264.5 404.1h-16.6v-6.3h16.6z"
  })), _linearGradient199 || (_linearGradient199 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 312.7,
    x2: 340.4,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cS)",
    d: "M256.2 423v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient200 || (_linearGradient200 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 326.7,
    x2: 354.4,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cT)",
    d: "M264.5 410.4h8.3v6.3h-8.3z"
  })), _linearGradient201 || (_linearGradient201 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 298.8,
    x2: 326.5,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cU)",
    d: "M264.5 416.7h-16.6v-6.3h16.6z"
  })), _linearGradient202 || (_linearGradient202 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 326.7,
    x2: 354.4,
    y1: 216,
    y2: 216,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cV)",
    d: "M264.5 423h8.3v5.7h-8.3z"
  })), _linearGradient203 || (_linearGradient203 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 312.7,
    x2: 340.4,
    y1: 226.1,
    y2: 226.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cW)",
    d: "M256.2 435v-6.2h16.6V435.1h-8.3v-.1z"
  })), _linearGradient204 || (_linearGradient204 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 298.8,
    x2: 326.5,
    y1: 236.1,
    y2: 236.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cX)",
    d: "M247.9 440.8V435h16.6v5.8h-8.3z"
  })), _linearGradient205 || (_linearGradient205 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 298.8,
    x2: 326.5,
    y1: 256.75,
    y2: 256.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cY)",
    d: "M247.9 453.4v-6.3h16.6v6.3z"
  })), _linearGradient206 || (_linearGradient206 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 326.7,
    x2: 354.4,
    y1: 256.8,
    y2: 256.8,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cZ)",
    d: "M264.5 447.2h8.3v6.3h-8.3z"
  })), _linearGradient207 || (_linearGradient207 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 312.7,
    x2: 340.4,
    y1: 246.25,
    y2: 246.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#da)",
    d: "M256.2 447.1v-6.3h16.6V447.2h-8.3v-.1z"
  })), _linearGradient208 || (_linearGradient208 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 326.7,
    x2: 354.4,
    y1: 236.17,
    y2: 236.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#db)",
    d: "M264.5 435.1h8.3v5.7h-8.3z"
  })), _linearGradient209 || (_linearGradient209 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 298.8,
    x2: 326.5,
    y1: 216,
    y2: 216,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dc)",
    d: "M264.5 428.8h-16.6V423h16.6z"
  })), _linearGradient210 || (_linearGradient210 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 285,
    x2: 312.7,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dd)",
    d: "M247.9 410.4H239.6v-6.3h16.6v6.3z"
  })), _linearGradient211 || (_linearGradient211 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 285.15,
    x2: 312.85,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#de)",
    d: "M239.7 397.8h8.2v6.3h-8.2z"
  })), _linearGradient212 || (_linearGradient212 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 285,
    x2: 312.7,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#df)",
    d: "M247.9 423H239.6v-6.3h16.6v6.3z"
  })), _linearGradient213 || (_linearGradient213 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 285.15,
    x2: 312.85,
    y1: 216,
    y2: 216,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dg)",
    d: "M239.7 423h8.2v5.7h-8.2z"
  })), _linearGradient214 || (_linearGradient214 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 285.15,
    x2: 312.85,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dh)",
    d: "M239.7 410.4h8.2v6.3h-8.2z"
  })), _linearGradient215 || (_linearGradient215 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 285,
    x2: 312.7,
    y1: 226.1,
    y2: 226.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#di)",
    d: "M247.9 435.1H239.6v-6.3h16.6v6.2h-8.3z"
  })), _linearGradient216 || (_linearGradient216 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 285.15,
    x2: 312.85,
    y1: 256.8,
    y2: 256.8,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj)",
    d: "M239.7 447.2h8.2v6.3h-8.2z"
  })), _linearGradient217 || (_linearGradient217 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 285,
    x2: 312.7,
    y1: 246.25,
    y2: 246.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dk)",
    d: "M239.7 440.8h16.5v6.3h-8.3v.1H239.6v-6.4z"
  })), _linearGradient218 || (_linearGradient218 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 285.15,
    x2: 312.85,
    y1: 236.17,
    y2: 236.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dl)",
    d: "M239.7 435.1h8.2v5.7h-8.2z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M330.8 347.6h8.3v6.2h0v-6.2h33.2v6.3h0v6.2h0v6.3h0v6.3h0v6.3h-.1v6.1h0v6.2h0v6.3h0v6.3h0v6.3h0v6.3H339v-6.3h0v-6.3h0v-6.3h0v-6.3h0v-6.2h0V381c-.1-.7-.2-1.3-.4-1.9-.8-2.3-2.6-4.4-5.5-6.3-.7-.5-1.5-.9-2.3-1.3l-.1-.1c-.4-.2-.7-.4-1.1-.5-1-.5-1.9-.9-2.9-1.3-.1 0-.2-.1-.4-.1-1.2-.5-2.5-.9-3.9-1.2-.5-.1-.9-.3-1.4-.4-.3-.1-.5-.1-.7-.2-2.9-.6-6-1.1-9.2-1.3h-10.4c-1.9.1-3.8.3-5.6.6-2 .3-3.9.7-5.8 1.2-1.7.5-3.3 1-4.8 1.6-.1 0-.1 0-.1.1-.7.3-1.5.6-2.2 1-.4.2-.7.4-1.1.6-.1 0-.1 0-.2.1-.8.4-1.5.8-2.2 1.3-2 1.3-3.4 2.7-4.4 4.2-.2.2-.3.5-.4.7-.3.5-.5.9-.6 1.4-.3.8-.4 1.6-.4 2.5v3.6m-.1-.1V404m0 .1v12.6m0 0v12m0 .7v5.6m0 .1v5.7m0 .6v5.7m0 .1v6.3h-33.1v-6.3h0v-6.3h0v-5.7h0v-6.3h0V423h0v-6.3h0v-6.3h0v-6.3h0v-6.3h0v-6.3h0v-6.2h0V379h0v-6.1h0v-6.3h0v-6.3h0V354h0v-6.2h33.1v6.2h0v-6.2H306v6.2h0v-6.2h24.8v6.2m8.3-.2h-16.5v6.3h16.5v-6.3 0m0 6.3v6.3h0v-6.3zm0 0v0m8.3 0v0h8.3v-6.3h-16.5m8.2 6.3h-8.2m8.2-6.3v-6.2m-33.1 12.5h8.2m-8.3-6.2v0l-8.2-.1m0 12.5h1c1.4 0 2.8 0 4.2.1h3v-6.3H306v6.3m8.2-6.3v0m0-6.3v-6.2m8.3 6.3h-8.2m8.2 14.3v-1.8h-8.3v0m33.2 6.4v0h8.3v-6.3h-16.5m8.2 12.3v-6.1h-8.2v6.1h8.2zm-8.3-12.4v0m0 6.4v0m0 0v-6.3h-8.2v0h-8.3m16.5 12.3v0m0 .3v-.2h.1v-6.1m-.1 6.3h-.4m.4 1.9v-1.9m-5.9-6.3h5.9m8.2 18.6v-6.2h-8.2m8.2 0v0l8.3-.1v-6.3h-8.3m-8.2 12.6h16.5m-24.8-31.3v6.3m16.6 0v-6.3m8.3 0h8.3v0h8.3v0m-16.6-6.3h8.3v-6.2m0 6.2h8.3v.1m-8.3 12.5h8.3v0m0 6.3v0H364v6.1h8.2v.2m-16.5-6.3h8.3v0m-8.3 6.1h8.3m-8.3-12.4h8.3v-6.3m-8.3 31.3h8.3v-6.3h-8.3m8.2 6.3h8.3m0-6.2h-8.3m-8.2 25.1h8.3v.1h8.3m-16.6-6.3v6.3m0-6.3h8.3v-6.3h-16.6v6.3h8.3zm0 18.9h8.3v.1h8.3v-6.3h-16.6v6.2zm8.2-18.9h8.3m-8.3-6.3h8.3m-8.3 12.6v6.3m8.3 12.6v6.3h0v5.7h0v6.3h0v6.3H339v-6.3h0v-6.3h0v-5.7h0v-6.3h0V423h0v-6.3h16.6m.1 12.6h8.3V423m-8.3 6.3v6.3h8.3v.1h8.3m-16.7 11.9v-6.3h-16.5m16.5 6.3h8.3v.1h8.3m-8.3 0v6.3m-8.3-12.7h8.3v-5.7m0 5.7h8.3m-8.3-12h8.3V423m-24.9-12.6v0l8.3-.1m-8.3 12.7v0l8.3-.1m-8.3-25.1h-8.2m8.2 18.9v-6.3h-8.2m8.2 12.6h-8.2m0-18.9h8.2m0 31.5v0l8.3-.1m-8.3 12.2v0l8.3-.1m-8.3 6.3v-6.3h-8.2m8.2-6.3v-5.7h-8.2m0-6.3h8.2V423m0 6.3h8.3m.1-37.9v6.3m-107.8-43.9h8.3m0 0h8.2v-6.2m-8.2 12.5v0h-8.4v6.3h16.6v-6.3h-8.2zm0-6.3v6.3m-8.3-6.3v-6.2m-8.2 6.2h8.2m0 6.3h-8.2m8.2 18.7v-6.1h-8.2m8.2 6.1h8.3m0 0h8.2v-6.1h-16.6v0m8.4 0v-6.3m-8.3 18.8v0l8.4-.1v-6.3m-8.4 12.6v-6.2h-8.2m8.2 6.2h8.3m0 0h8.2v-6.3h-8.2m-16.5-18.7h8.2m-8.2 12.4h8.2m-8.2 12.6h8.2m41.5-31.3v-6.2h-8.3v-.1h-8.2m33 0v0m-8.2 0v0l-8.3.1m0 6.2h8.3v0h8.2v-6.3h-8.2m8.3 6.3v6.2h0m0 0h-1c-1.4 0-2.8 0-4.2.1m5.2-6.3v0m-8.3-12.5v6.2m-24.9 6.3v0h-8.3m8.3 0v6.3h0v-6.3zm8.3 0v0h8.3m-16.6 0v-6.3h-8.3m16.6 6.3h-8.2m8.2-6.3v-6.2m8.3 18.8h-8.3v0h-8.2m-.1 6.4v6.1m0 .2v2.5m0-15.2v6.3h-8.3m8.3.1v6.3h.4m5.5-6.3h-5.9m-8.3-6.4h8.3m0 18.8h-8.3m0-6.4h8.3m-8.3 12.6h8.3m24.9-25v0h-8.3v1.7m8.3-1.7h3m5.3 0v-.1m-24.9.1v-6.3m16.6 0v6.3m-33.2 37.7v-6.3h-16.6v6.3h24.9m-8.3-6.3h8.3m-8.3 12.6h8.3m-8.3 12.6h8.3m-8.3-6.3h8.3m-8.3 0v-6.3h-16.6v6.3h16.6v0zm-8.3 18.3h8.3v.1h8.3m-8.3 18.3V447h-16.6v6.4m16.6-6.2h8.3m-8.3-18.4h8.3m-8.3 12v-5.7m0 5.7h8.3m-8.3-12V423h-16.6v5.7h16.6zm-8.3-18.4v-6.3m0 18.9v-6.3m-16.5-18.9h8.2m-8.2 6.3h8.2m-8.2 6.3h8.2m-8.2 6.3h8.2m-8.2 6.3h8.2m8.3 12v-6.2m-8.3 6.3v0l8.3-.1m-8.3 5.8h16.6m-8.3 6.3v-6.3m-8.3 6.4h-8.2m0-18.4h8.2m0 6.3h-8.2m8.2 5.7v-5.7m-8.2 5.7h8.2m8.3-49.4v6.3m49.8-37.6v0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 0.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M338.8 379.6c-.1-.3-.1-.5-.2-.7-1.1-3.1-4.1-5.8-8.9-8.1-6.3-3-13.8-4.5-22.7-4.5h-2c-8.9 0-16.4 1.5-22.7 4.5-4.8 2.3-7.8 5-8.9 8.1-.1.2-.2.5-.2.7m65.4-.7h33.8m-132.4 0h33.3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3
  })), _linearGradient219 || (_linearGradient219 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: -43,
    x2: -15.3,
    y1: 90.395,
    y2: 90.395,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 353.8v.2h-3.4l1.3-6.3h2.1v6.1zm-1.4-1.4-.1-.1s-.1 0-.1.1v.1h.1l.1-.1z",
    fill: "url(#dm)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3 390.4c-.1 0-.1 0 0 0l-.2-.1v-.2c0-.2.1-.2.2-.2v.5zm-23.5-38-.1.1h-.1v-.1s0-.1.1-.1l.1.1zm95.6 37.6c.1-.1.2 0 .2.2v.2h-.2v-.4zm25.5-37.2.1-.1s.1 0 .1.1v.1h-.1l-.1-.1zm-1.7-.4h-.2l.1-.1.1.1zm8.3 31.3v.1h-.1l-.1-.1h.2c-.1-.1-.1 0 0 0zM198 438c.1 0 .1.1.1.1v.1h-.1l-.1-.1.1-.1zm-3.3-10.7.1.1v.1h-.1l-.1-.1.1-.1zM77.8 411.2c0 .1 0 .1-.1.2-.1 0-.1.1-.2.1-.2 0-.3-.1-.3-.2s.1-.2.2-.2c.3-.1.4 0 .4.1zm-35.7 16.3c-.1-.1-.1-.2 0-.2l.1.1-.1.1z",
    fill: "#666"
  })), _linearGradient220 || (_linearGradient220 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: -28.95,
    x2: -1.25,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dn)",
    d: "M60.2 360.1h-4.7l1.3-6.1h3.4v-.2.1h8.4v6.2z"
  })), _linearGradient221 || (_linearGradient221 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: -15.15,
    x2: 12.55,
    y1: 90.195,
    y2: 90.195,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#do)",
    d: "M76.9 347.6v6.3H60.2v-6.3z"
  })), _linearGradient222 || (_linearGradient222 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: -15.15,
    x2: 12.55,
    y1: 111.17,
    y2: 111.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dp)",
    d: "M76.9 360.1v6.3H60.2v-6.3h8.4z"
  })), _linearGradient223 || (_linearGradient223 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: -43,
    x2: -15.3,
    y1: 111.5,
    y2: 111.5,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 366.4v.2h-6v-.2l1.3-6.2h4.7v6.2zh-6 6z",
    fill: "url(#dq)"
  })), _linearGradient224 || (_linearGradient224 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: -28.95,
    x2: -1.25,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dr)",
    d: "M60.2 366.4h8.4v6.3h-8.4v.1-.1h-7.3l.5-2.6.8-3.5h6z"
  })), _linearGradient225 || (_linearGradient225 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: -15.15,
    x2: 12.55,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ds)",
    d: "M76.9 378.8v.3H60.2V372.7H76.9v.1z"
  })), _linearGradient226 || (_linearGradient226 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: -43,
    x2: -15.3,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dt)",
    d: "M51.9 379.1v-.1h-.4l.2-.8 1.2-5.5h7.3V379.1H52z"
  })), _linearGradient227 || (_linearGradient227 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: -56.9,
    x2: -29.2,
    y1: 142.77,
    y2: 142.77,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#du)",
    d: "M51.9 385.3h-1.7l1.3-6.3h.4v.1z"
  })), _linearGradient228 || (_linearGradient228 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: -28.95,
    x2: -1.25,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dv)",
    d: "M52 385.2v-6.1h8.2v-.3.3h8.4v6h-8.4v.1z"
  })), _linearGradient229 || (_linearGradient229 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: -43,
    x2: -15.3,
    y1: 153.35,
    y2: 153.35,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9 391.6h-3v-.1l1.3-6.2h10v6.3h-8.3zm8.3-.1H48.9h11.3z",
    fill: "url(#dw)"
  })), _linearGradient230 || (_linearGradient230 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx",
    x1: -15.15,
    x2: 12.55,
    y1: 153.02,
    y2: 153.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dx)",
    d: "M68.6 391.4h-8.4v-6.3H76.9V391.4z"
  })), _linearGradient231 || (_linearGradient231 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dy",
    x1: -28.95,
    x2: -1.25,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dy)",
    d: "M68.6 391.4v6.4H52v-6.2h8.2v-.2z"
  })), _linearGradient232 || (_linearGradient232 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: -56.9,
    x2: -29.2,
    y1: 163.92,
    y2: 163.92,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9 397.9h-4.4l.1-.2 1.3-6.1h3v6.3zm-4.3-.1h4.3-4.3z",
    fill: "url(#dz)"
  })), _linearGradient233 || (_linearGradient233 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dA",
    x1: 40.4,
    x2: 68.1,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dA)",
    d: "M93.4 353.8v-6.2H110.1v6.2h-8.4z"
  })), _linearGradient234 || (_linearGradient234 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dB",
    x1: 26.5,
    x2: 54.2,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dB)",
    d: "M93.4 360.1H85.1v-6.3h16.6v6.3z"
  })), _linearGradient235 || (_linearGradient235 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dC",
    x1: 40.4,
    x2: 68.1,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dC)",
    d: "M93.4 366.4v-6.3H110.1v6.3h-8.3z"
  })), _linearGradient236 || (_linearGradient236 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dD",
    x1: 54.25,
    x2: 81.95,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dD)",
    d: "M101.7 353.8h16.6v6.3h-16.6z"
  })), _linearGradient237 || (_linearGradient237 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dE",
    x1: 26.7,
    x2: 54.4,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dE)",
    d: "M93.4 347.6v6.2h-8.2v-6.2h1.3z"
  })), _linearGradient238 || (_linearGradient238 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dF",
    x1: 68.25,
    x2: 95.95,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dF)",
    d: "M118.3 353.8h-8.2v-6.2h8.2z"
  })), _linearGradient239 || (_linearGradient239 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dG",
    x1: 12.75,
    x2: 40.45,
    y1: 121.6,
    y2: 121.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9 353.8v-6.2h8.3v6.2h-8.3zm8.3 19v6.1h-8.3v-6.1h8.3zm0-6.4h-8.3v-6.3h8.3v6.3zm-8.3 18.8h6.5l-1 4.8c-.1-.1-.2 0-.2.2v.2h.2l-.2 1H77v-3.1l-.1-3.1z",
    fill: "url(#dG)"
  })), _linearGradient240 || (_linearGradient240 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dH",
    x1: -1.25,
    x2: 26.45,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dH)",
    d: "M76.9 353.8h8.2v6.3H68.6v-6.2h8.3z"
  })), _linearGradient241 || (_linearGradient241 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dI",
    x1: -1.25,
    x2: 26.45,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dI)",
    d: "M76.9 372.8v-.1h-8.3v-6.3h16.5v6.4z"
  })), _linearGradient242 || (_linearGradient242 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dJ",
    x1: 26.5,
    x2: 54.2,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dJ)",
    d: "M85.2 366.4h16.6V372.8H85.1v-6.4z"
  })), _linearGradient243 || (_linearGradient243 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dK",
    x1: -1.25,
    x2: 26.45,
    y1: 142.55,
    y2: 142.55,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4 385.2h-6.5v-.1h-8.3V379h8.3v-.2h8.3v.1h-.5l-.1.5-.1.3c-.4 1.9-.7 3.7-1.1 5.5zm1.3-6.4-.1.6.1-.6z",
    fill: "url(#dK)"
  })), _linearGradient244 || (_linearGradient244 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dL",
    x1: 26.7,
    x2: 54.4,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dL)",
    d: "M85.2 372.8h8.2v6.3H85.2z"
  })), _linearGradient245 || (_linearGradient245 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dM",
    x1: -1.25,
    x2: 26.45,
    y1: 163.6,
    y2: 163.6,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dM)",
    d: "M68.6 397.8v-6.4h13.5l-1.4 6.4h-3.8z"
  })), _linearGradient246 || (_linearGradient246 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dN",
    x1: 68.25,
    x2: 95.95,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dN)",
    d: "M118.3 372.8v6.3h-8.2v-6.3z"
  })), _linearGradient247 || (_linearGradient247 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dO",
    x1: 40.4,
    x2: 68.1,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dO)",
    d: "M101.8 372.7h8.3V379.1H93.4v-6.3h8.4z"
  })), _linearGradient248 || (_linearGradient248 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dP",
    x1: 54.25,
    x2: 81.95,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dP)",
    d: "M110.1 366.4h8.2v6.4h-8.2v-.1h-8.3v-6.3z"
  })), _linearGradient249 || (_linearGradient249 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dQ",
    x1: 26.7,
    x2: 54.4,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dQ)",
    d: "M85.2 360.1h8.2v6.3h-8.2z"
  })), _linearGradient250 || (_linearGradient250 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dR",
    x1: 68.25,
    x2: 95.95,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dR)",
    d: "M118.3 366.4h-8.2v-6.3h8.2z"
  })), _linearGradient251 || (_linearGradient251 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dS",
    x1: 123.7,
    x2: 151.4,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dS)",
    d: "M151.5 353.8h-8.3v-6.2h8.3z"
  })), _linearGradient252 || (_linearGradient252 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dT",
    x1: -150.45,
    x2: -122.75,
    y1: -381.19,
    y2: -381.19,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M159.9 347.6v6.2h-8.3v-6.2h8.3zm-7.2 17.9c0-.2.1-.4.4-.4s.4.1.4.4v.1c0 .1-.2.2-.4.2-.1 0-.2 0-.2-.1-.2 0-.2-.1-.2-.2zm.1-2.2-.1.1-.1-.1c.1 0 .1-.1.2 0zm1.4-1.6c0-.2.1-.4.4-.4s.4.1.4.4c0 .2-.1.3-.4.3-.1 0-.2 0-.3-.1 0 0-.1-.1-.1-.2zm-1.1-.8c.1 0 .1.1.1.1v.1h-.1l-.1-.1.1-.1z",
    fill: "url(#dT)"
  })), _linearGradient253 || (_linearGradient253 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dU",
    x1: 109.75,
    x2: 137.45,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dU)",
    d: "M134.9 353.8h16.6v6.3h-16.6z"
  })), _linearGradient254 || (_linearGradient254 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dV",
    x1: 95.85,
    x2: 123.55,
    y1: 111.17,
    y2: 111.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dV)",
    d: "M126.6 366.4v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient255 || (_linearGradient255 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dW",
    x1: -178.35,
    x2: -150.65,
    y1: -371.2,
    y2: -371.2,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dW)",
    d: "M159.9 347.6h16.6v6.3h-16.6v-.1z"
  })), _linearGradient256 || (_linearGradient256 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dX",
    x1: -164.45,
    x2: -136.75,
    y1: -381.65,
    y2: -381.65,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dX)",
    d: "M168.2 353.9v6.2h-16.6v-6.3h8.3v.1z"
  })), _linearGradient257 || (_linearGradient257 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dY",
    x1: -150.45,
    x2: -122.75,
    y1: -392.2,
    y2: -392.2,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M151.6 366.4v-6.3h8.3v6.3h-8.3zm1.5-5.5-.1.1.1.1h.1v-.1s-.1 0-.1-.1zm1.1.8c0 .1 0 .2.1.3s.1.1.3.1c.3 0 .4-.1.4-.3 0-.3-.1-.4-.4-.4-.2 0-.4.1-.4.3zm-1.4 1.6c-.1-.1-.2-.1-.2 0l.1.1.1-.1zm-.1 2.2c0 .1 0 .2.1.3s.2.1.2.1c.2 0 .3-.1.4-.2v-.1c0-.3-.1-.4-.4-.4-.2-.1-.3 0-.3.3z",
    fill: "url(#dY)"
  })), _linearGradient258 || (_linearGradient258 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dZ",
    x1: -178.35,
    x2: -150.65,
    y1: -392.17,
    y2: -392.17,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dZ)",
    d: "M176.5 360.1v6.3h-16.6v-6.3h8.3z"
  })), _linearGradient259 || (_linearGradient259 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea",
    x1: 95.85,
    x2: 123.55,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ea)",
    d: "M143.2 353.8h-16.6v-6.2h16.6z"
  })), _linearGradient260 || (_linearGradient260 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb",
    x1: 123.7,
    x2: 151.4,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eb)",
    d: "M143.2 360.1h8.3v6.3h-8.3z"
  })), _linearGradient261 || (_linearGradient261 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec",
    x1: 82,
    x2: 109.7,
    y1: 100.65,
    y2: 100.65,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ec)",
    d: "M126.6 360.1H118.3v-6.3h16.6v6.3z"
  })), _linearGradient262 || (_linearGradient262 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed",
    x1: 82.2,
    x2: 109.9,
    y1: 111.2,
    y2: 111.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ed)",
    d: "M118.4 360.1h8.2v6.3h-8.2z"
  })), _linearGradient263 || (_linearGradient263 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 82.2,
    x2: 109.9,
    y1: 90.12,
    y2: 90.12,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ee)",
    d: "M118.4 347.6h8.2v6.2h-8.2z"
  })), _linearGradient264 || (_linearGradient264 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 82.2,
    x2: 109.9,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ef)",
    d: "M118.4 372.8h8.2v6.3h-8.2z"
  })), _linearGradient265 || (_linearGradient265 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eg",
    x1: 95.85,
    x2: 123.55,
    y1: 132.3,
    y2: 132.3,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eg)",
    d: "M134.9 372.7h8.3V379.1h-16.6V372.7z"
  })), _linearGradient266 || (_linearGradient266 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh",
    x1: 82,
    x2: 109.7,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eh)",
    d: "M118.3 372.8v-6.4h16.6v6.3h-8.3v.1h-8.2z"
  })), _linearGradient267 || (_linearGradient267 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ei",
    x1: 109.75,
    x2: 137.45,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ei)",
    d: "M134.9 366.4h16.6v6.4h-8.3v-.1h-8.3z"
  })), _linearGradient268 || (_linearGradient268 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: -164.45,
    x2: -136.75,
    y1: -402.75,
    y2: -402.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ej)",
    d: "M159.9 372.8h-8.3V366.4h16.6v6.3h-8.3z"
  })), _linearGradient269 || (_linearGradient269 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: -178.35,
    x2: -150.65,
    y1: -413.3,
    y2: -413.3,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ek)",
    d: "M176.5 378.8v.3h-16.6V372.7h16.6v.1z"
  })), _linearGradient270 || (_linearGradient270 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "el",
    x1: -150.45,
    x2: -122.75,
    y1: -413.15,
    y2: -413.15,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#el)",
    d: "M159.9 372.8v6h-8.3v-6z"
  })), _linearGradient271 || (_linearGradient271 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "em",
    x1: -164.45,
    x2: -136.75,
    y1: -423.55,
    y2: -423.55,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M152.1 378.8h7.8v.2h8.3v6.1h-8.3v.1h-6.5c-.4-1.8-.8-3.6-1.1-5.4l-.1-.3-.1-.7.1.6-.1-.5h-.5v-.1h.5z",
    fill: "url(#em)"
  })), _linearGradient272 || (_linearGradient272 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 123.7,
    x2: 151.4,
    y1: 132.32,
    y2: 132.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#en)",
    d: "M143.2 372.8h8.3v6.3h-8.3z"
  })), _linearGradient273 || (_linearGradient273 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eo",
    x1: -178.35,
    x2: -150.65,
    y1: -434.02,
    y2: -434.02,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eo)",
    d: "M176.5 385.2h-16.6 16.6v6.2h-16.6v-6.3h16.6z"
  })), _linearGradient274 || (_linearGradient274 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: -150.45,
    x2: -122.75,
    y1: -434.07,
    y2: -434.07,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "m154.7 391.4-.2-1h.2v-.2c0-.2-.1-.2-.2-.2l-1-4.8h6.5v6.2h-5.3z",
    fill: "url(#ep)"
  })), _linearGradient275 || (_linearGradient275 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eq",
    x1: -164.45,
    x2: -136.75,
    y1: -444.6,
    y2: -444.6,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eq)",
    d: "M159.9 391.4h8.3v6.4H156.1l-1.4-6.4z"
  })), _linearGradient276 || (_linearGradient276 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: -206.2,
    x2: -178.5,
    y1: -371.4,
    y2: -371.4,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m179.1 347.7 1.3 6.2v.2h-3.8v-.2h3.8-3.8v-6.1h2.5zm.8 5.1.1.1h.1v-.1s0-.1-.1-.1l-.1.1zm-1.7-.4-.1-.1-.1.1h.2z",
    fill: "url(#er)"
  })), _linearGradient277 || (_linearGradient277 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "es",
    x1: -192.15,
    x2: -164.45,
    y1: -381.65,
    y2: -381.65,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#es)",
    d: "m180.4 354 1.3 6.1h-13.5v-6.2h8.3v-.1h.1v.2z"
  })), _linearGradient278 || (_linearGradient278 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "et",
    x1: -206.2,
    x2: -178.5,
    y1: -392.5,
    y2: -392.5,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#et)",
    d: "M176.6 366.4h6.4-6.4v-6.1h5.1l1.3 6.1.1.2h-6.5z"
  })), _linearGradient279 || (_linearGradient279 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eu",
    x1: -192.15,
    x2: -164.45,
    y1: -402.75,
    y2: -402.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eu)",
    d: "M176.6 372.8h-.1v-.1h-8.3v-6.3h8.4v.2h6.5l.7 3.5.5 2.6h-7.7z"
  })), _linearGradient280 || (_linearGradient280 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ev",
    x1: -206.2,
    x2: -178.5,
    y1: -413.3,
    y2: -413.3,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ev)",
    d: "m184.3 372.7 1.4 6.3h-.8v.1H176.6V372.7z"
  })), _linearGradient281 || (_linearGradient281 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: -192.15,
    x2: -164.45,
    y1: -423.55,
    y2: -423.55,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ew)",
    d: "M184.8 379.1v6.1h-8.3v-.1h-8.3v-6h8.3v-.3h.1v.3z"
  })), _linearGradient282 || (_linearGradient282 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: -220.1,
    x2: -192.4,
    y1: -423.77,
    y2: -423.77,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m185.7 379 1.3 6.2h-2.1 2.1v.1h-2.1V379h.8zm.8 4.7c-.1 0-.1-.1 0 0l-.1.1.1.1h.1l-.1-.2z",
    fill: "url(#ex)"
  })), _linearGradient283 || (_linearGradient283 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ey",
    x1: -206.2,
    x2: -178.5,
    y1: -434.35,
    y2: -434.35,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M176.6 385.3H187l.6 3 .7 3.3h-11.8v-.1l.1-6.2zm8.2 6.3h-8.2v-.1h11.8v.1h-3.6z",
    fill: "url(#ey)"
  })), _linearGradient284 || (_linearGradient284 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ez",
    x1: -192.15,
    x2: -164.45,
    y1: -444.6,
    y2: -444.6,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ez)",
    d: "M176.5 397.8h-8.3v-6.4h8.4v.2h8.2v6.2z"
  })), _linearGradient285 || (_linearGradient285 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eA",
    x1: -220.1,
    x2: -192.4,
    y1: -444.92,
    y2: -444.92,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eA)",
    d: "m188.4 391.6 1.2 6.2.1.1h-4.8v-.1h4.7-4.7v-6.2z"
  })), _linearGradient286 || (_linearGradient286 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eB",
    x1: -206.2,
    x2: -178.5,
    y1: -455.5,
    y2: -455.5,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eB)",
    d: "M176.6 397.9H189.7l1.3 6.1v.3H176.6V404H191h-14.4z"
  })), _linearGradient287 || (_linearGradient287 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eC",
    x1: -220.1,
    x2: -192.4,
    y1: -465.95,
    y2: -465.95,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eC)",
    d: "M184.9 410.4v-6.1h6.1l1.3 6.1z"
  })), _linearGradient288 || (_linearGradient288 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eD",
    x1: -233.9,
    x2: -206.2,
    y1: -480.02,
    y2: -480.02,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eD)",
    d: "M193.7 416.9h-.6v-.1h.1v-2.2z"
  })), _linearGradient289 || (_linearGradient289 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eE",
    x1: -220.1,
    x2: -192.4,
    y1: -486.75,
    y2: -486.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eE)",
    d: "M184.9 416.9H193.7l1.2 5.8h-10z"
  })), _linearGradient290 || (_linearGradient290 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eF",
    x1: -206.2,
    x2: -178.5,
    y1: -476.4,
    y2: -476.4,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eF)",
    d: "M193.1 416.8h-16.5V410.4H192.3l.9 4.2v2.2z"
  })), _linearGradient291 || (_linearGradient291 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eG",
    x1: -206.2,
    x2: -178.5,
    y1: -496.85,
    y2: -496.85,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eG)",
    d: "M193.2 428.9h-8.3v.1H176.6v-6.2h16.6-16.6v-.1h16.6v.1z"
  })), _linearGradient292 || (_linearGradient292 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH",
    x1: -233.9,
    x2: -206.2,
    y1: -496.77,
    y2: -496.77,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m195.2 424.2.4 1.9c-.1 0-.1.1-.1.2 0 .2.1.2.2.2l.5 2.3h-3v-6.1h1.6-1.6v-.2h1.7l.2 1c-.1 0-.1-.1-.2-.1-.2 0-.4.1-.4.4 0 .1 0 .2.1.3s.1.1.2.1c.3.2.4.1.4 0zm-.5 3.1-.1.1.1.1h.1v-.1s0-.1-.1-.1z",
    fill: "url(#eH)"
  })), _linearGradient293 || (_linearGradient293 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI",
    x1: -192.15,
    x2: -164.45,
    y1: -465.75,
    y2: -465.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eI)",
    d: "M184.8 404.3v6.1h-16.6v-6.3h8.4v.2z"
  })), _linearGradient294 || (_linearGradient294 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eJ",
    x1: -178.35,
    x2: -150.65,
    y1: -455.17,
    y2: -455.17,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eJ)",
    d: "M159.9 404.1v-6.3h16.6v6.3h-8.3z"
  })), _linearGradient295 || (_linearGradient295 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eK",
    x1: -164.45,
    x2: -136.75,
    y1: -465.75,
    y2: -465.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eK)",
    d: "M168.2 410.4h-9.5l-1.3-6.3h10.8z"
  })), _linearGradient296 || (_linearGradient296 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eL",
    x1: -164.45,
    x2: -136.75,
    y1: -486.9,
    y2: -486.9,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eL)",
    d: "M168.2 422.8v.2h-6.8v-.2h6.8-6.8l-1.3-6.1h8.1z"
  })), _linearGradient297 || (_linearGradient297 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eM",
    x1: -192.15,
    x2: -164.45,
    y1: -486.9,
    y2: -486.9,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2 416.7h8.3v.1h8.2v5.9h-8.2v.4h-8.3v-6.4zm8.4 6.1h-8.3 8.3z",
    fill: "url(#eM)"
  })), _linearGradient298 || (_linearGradient298 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eN",
    x1: -178.35,
    x2: -150.65,
    y1: -497,
    y2: -497,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eN)",
    d: "m162.6 428.8-1.2-5.8H176.5v5.8h-8.3z"
  })), _linearGradient299 || (_linearGradient299 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eO",
    x1: -178.35,
    x2: -150.65,
    y1: -476.32,
    y2: -476.32,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eO)",
    d: "M159.9 416.1v-5.7h16.6v6.3h-16.4z"
  })), _linearGradient300 || (_linearGradient300 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eP",
    x1: -220.1,
    x2: -192.4,
    y1: -506.85,
    y2: -506.85,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eP)",
    d: "m196.2 428.9 1.2 5.8h-12.5v-5.8h8.3z"
  })), _linearGradient301 || (_linearGradient301 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eQ",
    x1: -192.15,
    x2: -164.45,
    y1: -507.1,
    y2: -507.1,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2 428.8h8.3v.2h8.2v5.7h-8.2v.5-.2h-8.3v-6.2zm0 .2h8.3-8.3zm8.4 5.8h-8.3 8.3z",
    fill: "url(#eQ)"
  })), _linearGradient302 || (_linearGradient302 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eR",
    x1: -178.35,
    x2: -150.65,
    y1: -517.1,
    y2: -517.1,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eR)",
    d: "M176.5 440.8h-11.4l-1.2-5.8H176.5v.1z"
  })), _linearGradient303 || (_linearGradient303 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eS",
    x1: -206.2,
    x2: -178.5,
    y1: -517,
    y2: -517,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eS)",
    d: "M184.8 441h-8.2v-.2l16.6-.1-16.6.1v-6.1h16.6v6.3h-8.3z"
  })), _linearGradient304 || (_linearGradient304 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eT",
    x1: -164.45,
    x2: -136.75,
    y1: -507.02,
    y2: -507.02,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eT)",
    d: "m163.8 434.8-1.1-5.8h5.5-5.5l-.1-.2h5.6v6h-4.4 4.4v.2h-4.3z"
  })), _linearGradient305 || (_linearGradient305 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eU",
    x1: -164.45,
    x2: -136.75,
    y1: -527.2,
    y2: -527.2,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eU)",
    d: "M168.2 440.8v6.3h-1.8l-1.3-6.3z"
  })), _linearGradient306 || (_linearGradient306 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eV",
    x1: -192.15,
    x2: -164.45,
    y1: -527.25,
    y2: -527.25,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eV)",
    d: "M176.6 440.8v.2h8.2v6.1h-8.2v.1h-.1v-.1h-8.3v-6.3h8.3z"
  })), _linearGradient307 || (_linearGradient307 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eW",
    x1: -178.35,
    x2: -150.65,
    y1: -537.75,
    y2: -537.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eW)",
    d: "M166.4 447.1H176.5v6.3h-8.7z"
  })), _linearGradient308 || (_linearGradient308 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eX",
    x1: -220.1,
    x2: -192.4,
    y1: -527.32,
    y2: -527.32,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eX)",
    d: "M200.1 447.1h-15.2V441h13.9l1 4.7z"
  })), _linearGradient309 || (_linearGradient309 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eY",
    x1: -206.2,
    x2: -178.5,
    y1: -537.75,
    y2: -537.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eY)",
    d: "M184.9 447.1H193.2v6.3h-16.6v-6.3h8.2z"
  })), _linearGradient310 || (_linearGradient310 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ",
    x1: -233.9,
    x2: -206.2,
    y1: -516.94,
    y2: -516.94,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m198.6 440 .1.7h-5.5 5.5l.1.3h-5.6v-6.3h4.2l.3 1.4c-.1 0-.2.1-.2.2 0 0 0 .1.1.1l.1.1h.1l.7 3.2v.1c0 .1 0 .2.1.2zm-.6-2-.1.1.1.1h.1v-.1l-.1-.1z",
    fill: "url(#eZ)"
  })), _linearGradient311 || (_linearGradient311 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: -233.9,
    x2: -206.2,
    y1: -537.75,
    y2: -537.75,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fa)",
    d: "M201.4 453.4h-8.2v-6.3h6.9z"
  })), _linearGradient312 || (_linearGradient312 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: -150.45,
    x2: -122.75,
    y1: -465.22,
    y2: -465.22,
    gradientTransform: "rotate(180 34.963 64.44) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m157.4 404.1-1.3-6.3h3.9v6.3h-2.6zm2.5 12-1.2-5.7h1.2v5.7z",
    fill: "url(#fb)"
  })), _linearGradient313 || (_linearGradient313 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 12.75,
    x2: 40.45,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fc)",
    d: "M76.9 404.1v-6.3h3.8l-1.3 6.3z"
  })), _linearGradient314 || (_linearGradient314 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd",
    x1: -1.25,
    x2: 26.45,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fd)",
    d: "M76.9 410.4h-8.3v-6.3h10.8l-1.3 6.3z"
  })), _linearGradient315 || (_linearGradient315 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe",
    x1: 12.75,
    x2: 40.45,
    y1: 194.8,
    y2: 194.8,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9 416.1v-5.7h1.2l-1.2 5.7zm.9-4.9c0-.2-.1-.2-.3-.2s-.2.1-.2.2.1.2.3.2c0 0 .1 0 .2-.1-.1.1 0 0 0-.1z",
    fill: "url(#fe)"
  })), _linearGradient316 || (_linearGradient316 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: -15.15,
    x2: 12.55,
    y1: 174.17,
    y2: 174.17,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ff)",
    d: "M68.6 404.1h-8.4v-6.3H76.9v6.3z"
  })), _linearGradient317 || (_linearGradient317 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fg",
    x1: -28.95,
    x2: -1.25,
    y1: 184.75,
    y2: 184.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fg)",
    d: "M60.2 410.4H52v-6.1h8.2v-.2h8.4v6.3z"
  })), _linearGradient318 || (_linearGradient318 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: -1.25,
    x2: 26.45,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4 423h-6.8v-6.3h8.2l-1.4 6.3zm-6.8-.3h6.5-6.5z",
    fill: "url(#fh)"
  })), _linearGradient319 || (_linearGradient319 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fi",
    x1: -15.15,
    x2: 12.55,
    y1: 216,
    y2: 216,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fi)",
    d: "M60.2 428.8V423h15.2l-1.2 5.8h-5.6z"
  })), _linearGradient320 || (_linearGradient320 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj",
    x1: -15.15,
    x2: 12.55,
    y1: 195.32,
    y2: 195.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fj)",
    d: "M76.9 410.4v5.7l-.2.6H60.2v-6.3h8.4z"
  })), _linearGradient321 || (_linearGradient321 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fk",
    x1: -28.95,
    x2: -1.25,
    y1: 205.9,
    y2: 205.9,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fk)",
    d: "M68.6 423h-8.4v-.3h8.4H52v-5.9h8.2v-.1h8.4v6z"
  })), _linearGradient322 || (_linearGradient322 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fl",
    x1: -1.25,
    x2: 26.45,
    y1: 226.02,
    y2: 226.02,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fl)",
    d: "M72.9 435h-4.3v-6.2h5.6z"
  })), _linearGradient323 || (_linearGradient323 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm",
    x1: -28.95,
    x2: -1.25,
    y1: 226.1,
    y2: 226.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fm)",
    d: "M68.6 435h-8.4v.1-.4H52V429h8.2v-.2h8.4z"
  })), _linearGradient324 || (_linearGradient324 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fn",
    x1: -15.15,
    x2: 12.55,
    y1: 236.1,
    y2: 236.1,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fn)",
    d: "M60.2 440.8V435h12.7l-1.2 5.8h-3.1z"
  })), _linearGradient325 || (_linearGradient325 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fo",
    x1: -1.25,
    x2: 26.45,
    y1: 246.2,
    y2: 246.2,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fo)",
    d: "M68.6 447.1v-6.3h3.1l-1.4 6.3z"
  })), _linearGradient326 || (_linearGradient326 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp",
    x1: -28.95,
    x2: -1.25,
    y1: 246.25,
    y2: 246.25,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fp)",
    d: "M68.6 447.1h-8.4v.1-.1H52V441h8.2v-.2h8.4z"
  })), _linearGradient327 || (_linearGradient327 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fq",
    x1: -15.15,
    x2: 12.55,
    y1: 256.75,
    y2: 256.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fq)",
    d: "M60.2 447.2v-.1h10.1l-1.3 6.3h-8.8z"
  })), _linearGradient328 || (_linearGradient328 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fr",
    x1: -43,
    x2: -15.3,
    y1: 174.5,
    y2: 174.5,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fr)",
    d: "M51.9 404.3h-5.7l1.3-6.4H60.2v6.4H52z"
  })), _linearGradient329 || (_linearGradient329 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs",
    x1: -56.9,
    x2: -29.2,
    y1: 184.95,
    y2: 184.95,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fs)",
    d: "M51.9 410.4h-7l1.3-6.1h5.7z"
  })), _linearGradient330 || (_linearGradient330 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ft",
    x1: -43,
    x2: -15.3,
    y1: 195.4,
    y2: 195.4,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ft)",
    d: "M52 416.8h-8.4v-.2l1.3-6.2h15.3V416.8z"
  })), _linearGradient331 || (_linearGradient331 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: -70.7,
    x2: -43,
    y1: 200.67,
    y2: 200.67,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fu)",
    d: "M43.6 416.6v.2h.1v.1h-.2z"
  })), _linearGradient332 || (_linearGradient332 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv",
    x1: -56.9,
    x2: -29.2,
    y1: 205.75,
    y2: 205.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fv)",
    d: "M43.6 422.7h-1.3l1.2-5.8H51.9v5.8h-8.2z"
  })), _linearGradient333 || (_linearGradient333 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fw",
    x1: -43,
    x2: -15.3,
    y1: 215.85,
    y2: 215.85,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 423v5.9h-8.3v-.1h-8.3v-6.2h16.6v.4zm-4.1 6 4.1-.1-4.1.1z",
    fill: "url(#fw)"
  })), _linearGradient334 || (_linearGradient334 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fx",
    x1: -70.7,
    x2: -43,
    y1: 215.77,
    y2: 215.77,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6 422.7v6.2H41l1-4.5c.1 0 .1-.1.2-.1.1-.1.1-.2.1-.3 0-.2 0-.3-.1-.3l.2-1h1.2zm-1.5 4.8.1-.1-.1-.1c-.1 0-.1.1 0 .2z",
    fill: "url(#fx)"
  })), _linearGradient335 || (_linearGradient335 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fy",
    x1: -56.9,
    x2: -29.2,
    y1: 246.32,
    y2: 246.32,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fy)",
    d: "M43.6 447.1h-6.5l.3-1.4 1.1-4.7h13.4v6.1h-8.2z"
  })), _linearGradient336 || (_linearGradient336 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fz",
    x1: -70.7,
    x2: -43,
    y1: 256.75,
    y2: 256.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fz)",
    d: "M37.1 447.1h6.5v6.3h-7.8z"
  })), _linearGradient337 || (_linearGradient337 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fA",
    x1: -56.9,
    x2: -29.2,
    y1: 225.85,
    y2: 225.85,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fA)",
    d: "M51.9 434.7H39.8l1.2-5.8h10.9v.1z"
  })), _linearGradient338 || (_linearGradient338 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fB",
    x1: -43,
    x2: -15.3,
    y1: 236,
    y2: 236,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fB)",
    d: "M60.2 435.1v5.9H43.6v-6.3H60.2z"
  })), _linearGradient339 || (_linearGradient339 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fC",
    x1: -70.7,
    x2: -43,
    y1: 235.95,
    y2: 235.95,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fC)",
    d: "M43.6 434.7v6.3h-5.1l1.3-6.3z"
  })), _linearGradient340 || (_linearGradient340 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fD",
    x1: -43,
    x2: -15.3,
    y1: 256.75,
    y2: 256.75,
    gradientTransform: "translate(69.328 296.82) scale(.5977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  }))), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fD)",
    d: "M51.9 447.1H60.2v6.3H43.6v-6.3h.1z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m58.2 347.7 2.1-.1h24.9v6.2h0v-6.2h33.3v6.2h0v-6.2h33v6.2h0v6.3h0v6.3h0v6.3h0v6.3h-33.1v-6.3h0v6.3H85.1v-6.3h0v6.2M69 453.4h-8.8m0-6.2v6.3H35.8m24.4-99.7v0-6.2m0 6.2v.2h-3.4m11.8-.1h-8.3v-.1m-.1 6.3v0h8.3v-6.2m-13 6.4h4.7m0 6.1v0-6.3h-4.7m-2.6 12.6h7.3v0h0v0h8.3v-6.3h-8.3m0 0v0h-6m-2.3 12.7v0h8.3v-6.3m-8.7 6.2h.4v.1m8.3-.3v0m8.4.3h-8.3v-6.3m-.1 12.4v0l8.3-.1V379M52 391.6v0m8.2 6.3v6.1h0v-6.3H52v-6.1m8.2-.2v.2m0-.2v0-6.2H52m-.1.1h8.3v6.1m-8.3-6.1v-6.2m-1.7 6.2h1.7m8.3 6.2H48.9m44.5-31.4v0h8.3v-6.3H85.2m16.5 6.3h8.3v0h8.2v-6.3h-16.5m8.4 0v-6.2m-16.7 6.2v-6.2m-8.3 6.2v0m-8.2 0v0l-8.3.1m0 6.2h8.3v0h8.3v-6.3h-8.3v-6.2m8.3 12.5v6.3h0v-6.3zm0 0v0m-.1 6.3v0m.1 6.4v0h-8.3v6.1h8.3m-.1-6.1v-6.3H68.6m8.3 6.3v0h-8.3m8.3 6v.2h-8.3m0 12.4h8.2v-6.3h-8.3m8.4 6.3h5.2m1.3-6.2h-6.5m33.2-12.4v6.3m-8.3-6.4v0h-8.3v6.3m16.6-12.6v0h-8.3v6.3h8.3v0h8.2v-6.3h-8.2v0zm-16.7 0h8.3v0m8.4-6.3v6.3m-16.7-6.3h-8.2m0 6.3h8.2v-6.3m-16.5 6.3v-6.3m16.5 12.7h-8.2m-16.6 18.6h-8.3m99.6-43.8h-8.3v6.2h8.3v-6.2zm-25 12.5h8.3v0h8.3m8.4-6.3v0l8.3.1h8.3v-.1h0v-6.1m0-.1h-16.6m-8.3 6.3v6.2m0 0h8.3v0h8.3v-6.2m-25-.1v-6.2m0 6.2h8.3m-33.2 6.3v0m.1 0v6.3h0v-6.3zm8.2 0v0h8.3v-6.3h-16.5m8.2 0v-6.2m0 12.5h-8.2m8.2 19v-6.3h-8.2m16.5-6.4h-16.5m16.5 6.3v-6.3h16.6m-24.9 6.4v0h16.6v0h8.3m-33.2-6.4v0m0 6.4v0m41.6 0v0h8.3v-6.3m0-.1h-16.5m-.1 0v6.3m0 .1h8.3m-8.3 6v.1m.5-.1h-.5m1.8 6.4h6.5v-.1m8.3 0V379h-8.3v-.2h-7.8m-.5-6v6.1m8.3-.1v-6.1m-16.7.1v6.3m16.7 12.3v-6.2m0 6.2h-5.2m1.4 6.4h12.2v-6.3m-.1-.1H160m-.1-25v-6.3m-8.3 0v6.3m-16.7-12.6h8.3m0 12.6v-6.3m-16.6 6.3v-6.3m52.5-12.4-2.5-.1m3.8 6.2h-3.8m0 0v0m0 12.6h6.4m-14.8-6.3h8.3v0h5.1m-5 6.3v0h-8.3m16 6.3h-7.8v6.3h8.3v0h.8m-9.1-6.2v0h-8.3m8.4 0v6.1h0m-8.4.2h8.3v-.2m10.5 6.3h-2.1m-8.4 0v0m.1 6.2v.1h11.8m-11.8.1v0m0-.2v0h-8.3m16.5.2v0m-8.2-6.3v6.1m-.1 0v-6.2h-16.6m16.6 0h8.2v-6.1m-8.1-12.7v0m-.1-6.3v6.3m13.1 31.4h-4.8m6.2 6.2h-14.4v.1h-8.3v6.3h16.5v-6.1h.1m8.3 10.3v2.2h-.1v.1h.6m-8.8 5.8v0m-8.3.1h16.6m1.5 0h-1.6v6.1h3m-3.8-18.5h-15.7v6.4h16.5m-8.3-19v0m-8.3 0h8.2v-6.1m-8.1 6.2v6.1m-.1.1v-6.3h-8.3m0 6.3h-10.7m1.2 6.3h9.5m0 6.3h-8.1m1.3 6.1h6.9v-6.1h8.3v-6.3m-.1 6.3v0m.1 12.1v.2h8.3v-.1h8.3m-16.6-5.9v5.7h0m8.2-11.9v5.9m-8.2.1h-8.3m16.5 11.9h-8.2v.5h0v5.7h0v-.1l16.6-.1v-6m-.1 0h-8.3m-8.3.4v0m-11.4 5.7h3m.1 0h8.3m8.4-11.8v5.7m-.1-5.7v5.7m-16.6-5.7v-.2m-5.5.2h13.9m-8.4 5.8h-4.4m4.4 0V429m-.4 24.4h8.8V447h-10.1m1.7.1v-6.3m16.7.2v0m-.1 0v0m0 0v6.1h.1m-8.4.1v0l8.2-.1m-8.1 6.3h16.6v-6.3m-.1 0h-8.2m-8.3-12.3h-8.3m29.1-.1h-4.2m5.5 6h-5.5m6.9 6.4h-6.9m0 6.3h8.2m-8.3-36.5h-8.2m-25-12.8v-6.3m0 18.3v-5.7m-83-12.6h3.9m-3.9 6.3h2.5m-2.5 6.3h1.2m-1.2-6.3v-6.3H60.3m8.3 6.3h8.2m-8.2 6.3v-6.3h-8.3m8.3 18.6v-5.9h-8.3v.1H43.7v.1h8.2v5.7h23.2m-6.5-6h8.1m.2-6.3H60.3v6.3m16.6-.6v-5.7m-8.3 18.4h5.6m-5.6 6.2v-6.2h-8.3v.2m-4.2 0H52v5.7h8.2v.4h0v-.1h12.6m-4.2 12.1h1.8m-1.8-6.3h3m-3 6.3v-6.3h-8.3v.2h-8.4m.1 6.1h8.2v.1m-8.3-42.9v6.2h8.3v6.3M52 404.3v0h-5.8m14-.2v.2H52m8.2 6.1H52m-8.3 6.5h-.1m.1-.1v0l-.1-.2m.1 6.1h8.2m-9.6 0h1.3m16.6 0v.4h0m-15.3-12.7h7m-4.3-12.6h4.3m0 31.2v0m0 0v0l-8.3-.1H41m10.9 5.8v0m4.2-5.7 4.1-.1m-16.6 5.8h-3.8m3.9 0h8.2m-8.2 12.4h8.2V441H38.5m5.1 12.4v-6.3h-6.5m23.1.1v0l8.3-.1m-16.6 0v0m-8.3-6.1v-6.3m16.6 6.1v-5.7m0 0v5.7m-16.6-11.9v-6.2m16.6 6.1V423m0 5.8V423m8.4-25.2v-6.3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 0.5
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m84.6 379.4-.1.3c-.4 1.8-.8 3.6-1.1 5.4l-1 4.8-.1.4-.2 1-3.9 18.9-1.2 5.7-.1.6-1.3 6.3-1.2 5.7-1.3 6.2-1.2 5.8-2.6 12.6m-33.5.3 1.3-6.3.3-1.4 1-4.7 1.3-6.3 1.2-5.8 1-4.5.1-.7.2-1 1.2-5.7.1-.3 2.6-12.4 1.3-6.3.1-.2 1.3-6.1v-.1l1.3-6.2 1.3-6.3.2-.8 1.2-5.4.5-2.6.7-3.5v-.2l1.3-6.2v-.1l1.3-6.1 1.3-6.3m26.8 30.9-.1.6m67.6 0-.1-.6m.1.6.1.3c.4 1.8.8 3.6 1.1 5.4l1 4.8.1.4.2 1 3.9 18.9 1.2 5.7.1.6 1.3 6.1v.2l1.2 5.7.1.2 1.2 5.8.1.2 1.2 5.8 2.6 12.6m12.8-99.1v-.2l-1.3-6.2m3.9 18.8-1.3-6.1v-.1l-1.3-6.1m3.9 18.6-.6-2.6-.7-3.5-.1-.3m2.8 12.7-1.3-6.3m2.6 12.6v0l-1.3-6.3m2.7 12.5-.7-3.3-.6-3m1.3 6.4v0m1.3 6.3v-.2l-1.3-6.1m2.6 12.7v-.3l-1.3-6.1m2.6 12.5-1.3-6.2m2.7 12.7-.5-2.3-.9-4.2m2.9 13.8-.1-.6-.2-1-1.2-5.7m2.5 12-.5-2.3-.1-.4-.4-1.9m2.7 12.3-.1-.4-.3-1.4-1.2-5.8m2.2 10.8-.7-3.2m.8 3.4-.1-.2m.3 1.2-.1-.3-.1-.7m1.5 7.1-.3-1.4-1-4.7m2.6 12.4-1.3-6.3M51.6 378.9h133.9",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 498.3c4.7 4.7 7.1 10.4 7.1 17.1s-2.4 12.4-7.1 17.1-10.4 7-17.1 7-12.4-2.3-17.1-7-7-10.4-7-17.1 2.3-12.4 7-17.1 10.4-7.1 17.1-7.1 12.4 2.4 17.1 7.1z",
    fill: "#7493B0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 518c0 .5 0 .8.1 1.1s.2.5.4.6.5.2 1 .2l1.6.1v.9h-9.1v-.9l1.7-.2c.6 0 1-.2 1.2-.5s.3-.8.2-1.4V512c0-.6 0-1.1-.2-1.3-.1-.2-.5-.3-1-.4l-1.6-.1v-.8c1-.1 1.9-.3 2.9-.5s1.9-.5 2.9-.8c-.1.1-.1 9.9-.1 9.9z",
    fill: "#fff"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M514.3 532.4c-4.7 4.7-10.4 7.1-17 7.1-6.7 0-12.4-2.4-17.1-7.1s-7.1-10.4-7.1-17.1 2.4-12.4 7.1-17.1 10.4-7 17.1-7 12.3 2.3 17 7 7.1 10.4 7.1 17.1-2.4 12.4-7.1 17.1z",
    fill: "#7493B0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M499.7 517.1c.3.6.4 1.2.4 1.8 0 .9-.2 1.7-.6 2.4s-.9 1.3-1.5 1.8-1.3.9-1.9 1.3c-.7.3-1.3.6-1.9.7-.6.2-1 .2-1.3.2-.6 0-1.1-.1-1.6-.3s-.8-.4-1.1-.6c-.2-.2-.3-.3-.4-.5s-.1-.4 0-.6.1-.3.3-.5c.1-.2.3-.3.4-.4s.3-.2.4-.2.3.1.4.2c.2.2.5.4.8.6s.7.4 1 .6c.4.2.8.2 1.2.3.5 0 .9-.1 1.3-.4s.7-.7 1-1.2c.2-.6.4-1.3.4-2.1s-.2-1.5-.5-2.1c-.3-.5-.7-.9-1.2-1.1s-.9-.4-1.4-.4c-.3 0-.6 0-.9.1s-.6.1-.8.2l-.2-.8c1.2-.5 2.2-1 2.9-1.6s1-1.4 1-2.2-.2-1.4-.6-1.8-.9-.6-1.6-.6c-.6 0-1.1.2-1.6.6s-.9.8-1.2 1.3l-.6-.6 1.2-1.7c.4-.4.8-.8 1.4-1 .6-.3 1.2-.4 1.9-.4 1.3 0 2.2.4 3 1 .7.6 1.1 1.5 1.1 2.6 0 .4-.1.7-.2 1s-.4.6-.7.8c-.2.2-.5.4-.8.7-.3.2-.7.5-1.1.7v.1c.9.1 1.6.4 2.2.8.7.3 1.1.8 1.4 1.3z",
    fill: "#fff"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M323 532.4c-4.7 4.7-10.4 7.1-17.1 7.1s-12.3-2.4-17-7.1-7.1-10.4-7.1-17.1 2.4-12.4 7.1-17.1 10.4-7.1 17-7.1c6.7 0 12.4 2.4 17.1 7.1s7.1 10.4 7.1 17.1-2.4 12.4-7.1 17.1z",
    fill: "#7493B0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M308 509.7c.4.6.5 1.3.6 2.1 0 .8-.2 1.6-.7 2.3s-1.3 1.4-2.4 2.2c-.3.2-.7.5-1.1.8s-.9.7-1.4 1.1v.1h4c.5 0 .9 0 1.1-.1.3-.1.5-.2.7-.4s.4-.5.6-1l.8.2-.9 3.6h-10.6v-.7c.6-.4 1.3-.9 2-1.4s1.4-1.1 2.1-1.7 1.3-1.3 1.7-2 .7-1.5.7-2.2c0-.5-.1-.9-.3-1.3s-.4-.7-.8-1c-.4-.2-.9-.4-1.5-.4-.5 0-1 .1-1.4.4-.4.2-.8.5-1.1.9-.3.3-.6.7-.8 1l-.7-.6 1.6-2.3c.5-.5 1-.9 1.6-1.2s1.3-.4 2.1-.4c.9 0 1.7.2 2.3.5.9.4 1.4.9 1.8 1.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem12B);
export default __webpack_public_path__ + "static/media/item12b.44c7e6db4560d6896d41062798a76079.svg";
export { ForwardRef as ReactComponent };